document.addEventListener('DOMContentLoaded', function () {
  // gsap arriva da CDN: se bloccato (VPN, adblock, antivirus) il resto dello script deve girare comunque
  const hasGsap = !!(window.gsap && window.ScrollTrigger);
  if (hasGsap) gsap.registerPlugin(ScrollTrigger);

  /* -- Porta la modale DENTRO il <dialog> e gestisci lo stack -- */
  (() => {
    const DIALOG_SEL = 'cart-drawer-component dialog.cart-drawer__dialog.dialog-modal.dialog-drawer';
    const MODAL_SEL  = 'invoice-modal';

    function moveInsideDialog() {
      const dlg = document.querySelector(DIALOG_SEL);
      const modal = document.querySelector(MODAL_SEL);
      if (!dlg || !modal) return;

      // Appendila come ULTIMO figlio del <dialog> (non dentro .cart-drawer__inner)
      if (!dlg.contains(modal)) dlg.appendChild(modal);
    }

    function ensureStyles() {
      if (document.getElementById('invoice-in-drawer-styles')) return;
      const s = document.createElement('style');
      s.id = 'invoice-in-drawer-styles';
      s.textContent = `
        /* La modale copre tutto lo stack del drawer */
        ${DIALOG_SEL} ${MODAL_SEL}{
          position: fixed !important;
          inset: 0 !important;
          z-index: 2147483647 !important; /* sopra a tutto */
        }

        /* Quando la modale è aperta, ammutolisci wallet/iframe */
        html.invoice-open .dynamic-checkout__content,
        html.invoice-open shopify-accelerated-checkout-cart,
        html.invoice-open .paypal-buttons iframe,
        html.invoice-open shopify-google-pay-button iframe {
          opacity: 0 !important;
          pointer-events: none !important;
        }
      `;
      document.head.appendChild(s);
    }

    function isOpen(modal){
      if (!modal) return false;
      const cs = getComputedStyle(modal);
      return cs.display !== 'none' && !modal.classList.contains('fi-hidden') &&
            modal.getAttribute('aria-hidden') !== 'true' && !modal.hasAttribute('hidden');
    }

    function watchOpenClose() {
      const modal = document.querySelector(MODAL_SEL);
      if (!modal || modal.__watching) return;
      modal.__watching = true;
      const toggle = () => document.documentElement.classList.toggle('invoice-open', isOpen(modal));
      new MutationObserver(toggle)
        .observe(modal, { attributes: true, attributeFilter: ['class','style','open','hidden','aria-hidden'] });
      toggle();
    }

    function keepReparented() {
      new MutationObserver(() => {
        const dlg = document.querySelector(DIALOG_SEL);
        const modal = document.querySelector(MODAL_SEL);
        if (dlg && modal && !dlg.contains(modal)) dlg.appendChild(modal);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    ensureStyles();
    moveInsideDialog();
    watchOpenClose();
    keepReparented();

    // ritenti nel caso i componenti montino tardi
    setTimeout(moveInsideDialog, 200);
    setTimeout(moveInsideDialog, 600);
  })();

  /* -- Chiudi il carrello quando appare il popup Swym -- */
  (() => {
    const SWYM_CONTAINER_SEL = '.swym-modals-container';
    const SWYM_MODAL_SEL     = '.swym-modal.swym-sfl-popup';

    function closeCartDrawer() {
      // prova a chiudere il componente custom
      const drawerComp = document.querySelector('cart-drawer-component');
      if (drawerComp && typeof drawerComp.close === 'function') {
        drawerComp.close();
      }

      // chiudi anche il <dialog> interno se esiste
      const dlg = document.querySelector('cart-drawer-component dialog.cart-drawer__dialog.dialog-modal.dialog-drawer');
      if (dlg) {
        if (typeof dlg.close === 'function') dlg.close();
        dlg.removeAttribute('open');
        dlg.classList.remove('is-open', 'active');
      }
    }

    function handleMutations(mutations) {
      for (const m of mutations) {
        if (m.type !== 'childList') continue;

        const added = [...m.addedNodes].filter(n => n.nodeType === 1);
        if (added.some(n => n.matches?.(SWYM_MODAL_SEL) || n.querySelector?.(SWYM_MODAL_SEL))) {
          closeCartDrawer();
          break;
        }
      }
    }

    function watchSwymContainer() {
      const container = document.querySelector(SWYM_CONTAINER_SEL);
      if (!container) return false;

      const mo = new MutationObserver(handleMutations);
      mo.observe(container, { childList: true, subtree: true });
      return true;
    }

    // 1) prova subito
    if (watchSwymContainer()) return;

    // 2) se Swym monta dopo, osserva finché non compare il container
    const rootMo = new MutationObserver(() => {
      if (document.querySelector(SWYM_CONTAINER_SEL)) {
        if (watchSwymContainer()) rootMo.disconnect();
      }
    });
    rootMo.observe(document.documentElement, { childList: true, subtree: true });

    // 3) qualche retry “di sicurezza”
    setTimeout(watchSwymContainer, 500);
    setTimeout(watchSwymContainer, 1500);
  })();


  /* Chiusura accordion filtri prodotti pagina collezione */
  const seeResultsBtn = document.querySelector('.facets__see-results');
  const accordion = document.querySelector('.facets-accordion');

  if (seeResultsBtn && accordion) {
    seeResultsBtn.addEventListener('click', () => {
      accordion.removeAttribute('open');
    });
  }

  /* Fix per mostrare tutti elmeneti del filtro */
  document.querySelectorAll("overflow-list").forEach(list => {
    if (typeof list.showAll === "function") list.showAll();
  });

  /* ===============================
   *  Gestione colore badge fragranza
   * =============================== */
  function parseColor(input) {
    if (!input) return null;
    input = String(input).trim();

    // HEX (#rgb, #rgba, #rrggbb, #rrggbbaa)
    if (input.startsWith('#')) {
      let hex = input.slice(1);
      if (hex.length === 3 || hex.length === 4) hex = hex.split('').map(c => c + c).join('');
      if (hex.length === 6 || hex.length === 8) {
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return [r, g, b]; // alpha ignorata
      }
      return null;
    }

    const m = input.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map(v => parseFloat(v.trim()));
      if (parts.length >= 3) return [parts[0], parts[1], parts[2]];
    }

    return null;
  }

  function luminanceFromRGB([r, g, b]) {
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  function getBadgeBgColor(el) {
    const varColor = el.style.getPropertyValue('--tag-color') || getComputedStyle(el).getPropertyValue('--tag-color');
    let rgb = parseColor(varColor);
    if (rgb) return rgb;

    rgb = parseColor(getComputedStyle(el).backgroundColor);
    if (rgb) return rgb;

    let p = el.parentElement;
    while (p) {
      const pbg = getComputedStyle(p).backgroundColor;
      const prgb = parseColor(pbg);
      if (prgb && !(pbg.includes('0)'))) return prgb; // evita fully transparent
      p = p.parentElement;
    }
    return [255, 255, 255]; // assume chiaro
  }

  function setBadgeTextColor(el) {
    const rgb = getBadgeBgColor(el);
    const lum = luminanceFromRGB(rgb);
    const color = lum > 0.5 ? '#000' : '#fff';
    el.style.color = color;
    const inner = el.querySelector?.('.product-badge_fragranza__text');
    if (inner) inner.style.color = color;
  }

  function updateAllTagColors() {
    document
      .querySelectorAll('.product-badge_fragranza, .intestazione_prodotto p, .product-badge_fragranza p')
      .forEach(setBadgeTextColor);
  }

  // Primo pass dopo il layout
  requestAnimationFrame(updateAllTagColors);
  window.addEventListener('load', updateAllTagColors);

  // Ricalcolo su mutazioni dinamiche
  const mo = new MutationObserver(mutations => {
    let needsUpdate = false;
    for (const m of mutations) {
      if (m.type === 'childList') {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches?.('.product-badge_fragranza') || n.querySelector?.('.product-badge_fragranza'))) {
            needsUpdate = true;
            break;
          }
        }
      }
      if (needsUpdate) break;
    }
    if (needsUpdate) updateAllTagColors();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* ===============================
   *  Helpers contrasto collezione (UNA SOLA COPIA)
   * =============================== */
  function getCssVarRgb(varName, scope = document.documentElement) {
    const val = getComputedStyle(scope).getPropertyValue(varName);
    return parseColor(val);
  }

  function pickContrastColorFrom(bgRgb) {
    if (!bgRgb) return '#000';
    const lum = luminanceFromRGB(bgRgb);
    return lum > 0.5 ? '#000' : '#fff';
  }

  /* ===============================
   *  Contrasto testo collezione → solo var CSS (niente style inline su h1/p)
   * =============================== */
  function applyCollectionTextContrastVar() {
    const main = document.querySelector('main[data-template="collection.fragrance-collection"]');
    if (!main) return;

    let rgb = getCssVarRgb('--collection-color', document.documentElement);
    if (!rgb) rgb = parseColor(getComputedStyle(main).backgroundColor);

    const text = pickContrastColorFrom(rgb);

    const targets = [ 
      '.hero_collection', 
      '.hero_collection h1', 
      '.hero_collection p'
    ];
    targets.forEach(sel => { 
      main.querySelectorAll(sel).forEach(el => { el.style.color = text; }); 
    });
  }

  requestAnimationFrame(applyCollectionTextContrastVar);
  window.addEventListener('load', applyCollectionTextContrastVar);
  document.addEventListener('shopify:section:load', applyCollectionTextContrastVar);
  document.addEventListener('shopify:section:reorder', applyCollectionTextContrastVar);
  window.addEventListener('locationchange', () => requestAnimationFrame(applyCollectionTextContrastVar));
  const collectionColorObserver = new MutationObserver(applyCollectionTextContrastVar);
  collectionColorObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });

  /* ===============================
   *  Bottoni collezione → secondary / quaternary (usa gli stessi helpers)
   * =============================== */
  function applyCollectionButtonClass() {
    const main = document.querySelector('main[data-template="collection.fragrance-collection"]');
    if (!main) return;

    let rgb = getCssVarRgb('--collection-color', document.documentElement);
    if (!rgb) rgb = parseColor(getComputedStyle(main).backgroundColor);

    const text = pickContrastColorFrom(rgb);
    const newClass = (text === '#fff') ? 'button-quaternary' : 'button-secondary';

    main.querySelectorAll('.hero_collection a, .hero_collection .button, .hero_collection button')
      .forEach(el => {
        el.classList.remove('button-quaternary', 'button-secondary');
        el.classList.add(newClass);
      });
  }

  requestAnimationFrame(applyCollectionButtonClass);
  window.addEventListener('load', applyCollectionButtonClass);
  document.addEventListener('shopify:section:load', applyCollectionButtonClass);
  document.addEventListener('shopify:section:reorder', applyCollectionButtonClass);
  window.addEventListener('locationchange', () => requestAnimationFrame(applyCollectionButtonClass));

  /* Testo circolare che ruota (scroll to next section) */
  document.querySelectorAll('.circle-wrapper').forEach(wrapper => {
    wrapper.addEventListener('click', (e) => {
      e.preventDefault();
      const currentSection = wrapper.closest('.shopify-section');
      let nextSection = currentSection?.nextElementSibling;
      while (nextSection && !nextSection.classList.contains('shopify-section')) {
        nextSection = nextSection.nextElementSibling;
      }
      if (nextSection) nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ===============================
  *  Overlay offset + snap panels + parallax (invariati)
  * =============================== */
  function computeTopOffset() {
    const header = document.querySelector('header-component');
    const headerHeight = header ? header.getBoundingClientRect().height || header.offsetHeight || 0 : 0;

    const bar = document.querySelector('.announcement-bar');
    let announcementOffset = 0;

    if (bar) {
      const rect = bar.getBoundingClientRect();
      const pos = getComputedStyle(bar).position;
      const isFixedOrSticky = pos === 'fixed' || pos === 'sticky';
      const touchesTop = rect.top <= 0 && rect.bottom > 0;
      const fullyBelowTop = rect.top >= 0;

      if (touchesTop) {
        announcementOffset = Math.min(rect.height, rect.bottom);
      } else if (fullyBelowTop && isFixedOrSticky) {
        announcementOffset = rect.height;
      }
    }

    return Math.max(0, headerHeight + announcementOffset - 1);
  }

  const OVERLAY_STYLE_ID = 'overlay-top-style';

  function ensureOverlayStyle() {
    let styleEl = document.getElementById(OVERLAY_STYLE_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = OVERLAY_STYLE_ID;
      document.head.appendChild(styleEl);
    }
    // Metti qui tutti i selettori degli overlay che devono rispettare l’offset
    styleEl.textContent = `
      dialog.search-modal__content,
      .account-popover__panel,
      [data-header-drawer],
      .menu-drawer__backdrop,
      .facets--drawer.dialog-modal {
        top: var(--overlay-top, 0px) !important;
      }
    `;
  }

  function applyTopToOverlays() {
    ensureOverlayStyle();
    const top = computeTopOffset();
    document.documentElement.style.setProperty('--overlay-top', `${top}px`);
  }

  function applyMediaHeight() {
    const top = computeTopOffset();
    let styleEl = document.getElementById('media-height-style');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'media-height-style';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = `
      @media (width > 48rem) {
        .product-information__media, .essenza_profumo, .utilizzo {
          min-height: calc(100vh - ${top}px)!important;
          box-sizing: border-box;
        }
      }
    `;
  }

  function initSnaps() {
    if (!hasGsap) return;
    const panels = gsap.utils.toArray(".product-information__media, .essenza_profumo, .utilizzo");
    if (panels.length === 0) return;

    ScrollTrigger.getAll().forEach(st => st.vars && st.vars.__snapPanel && st.kill());

    const getTop = () => (typeof computeTopOffset === "function" ? computeTopOffset() : 0);

    panels.forEach(panel => {
      ScrollTrigger.create({
        trigger: panel,
        start: () => `top-=${getTop()} top`,
        end:   () => `bottom-=${getTop()} top`,
        snap:  { snapTo: [0, 1], duration: 0.8, ease: "power2.out" },
        invalidateOnRefresh: true,
        __snapPanel: true
      });
    });

    ScrollTrigger.refresh();
  }

  window.addEventListener('load', () => {
    if (!hasGsap) return;
    const mm = gsap.matchMedia();

    const setupParallax = () => {
      ScrollTrigger.getAll().forEach(st => {
        if (st.vars && st.vars.id && st.vars.id.startsWith('parallax-essenza')) st.kill();
      });

      document.querySelectorAll('.essenza_profumo .background-image-container img').forEach((img, i) => {
        const section = img.closest('.essenza_profumo');
        if (!section) return;

        gsap.set(img, {
          scale: 1.12,
          transformOrigin: 'center center'
        });

        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        const startY = isDesktop ? -8 : -4;
        const endY   = isDesktop ?  8 :  4;

        gsap.fromTo(img,
          { yPercent: startY },
          {
            yPercent: endY,
            ease: 'none',
            scrollTrigger: {
              id: `parallax-essenza-${i}`,
              trigger: section,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.6,
              invalidateOnRefresh: true
            }
          }
        );
      });

      ScrollTrigger.refresh();
    };

    setupParallax();

    let resizeTO;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(() => setupParallax(), 150);
    });
  });

  // throttle con rAF
  let ticking = false;
  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      applyTopToOverlays();
      ticking = false;
    });
  }

  const isDesktop = () => window.matchMedia("(min-width: 768px)").matches;
  let snapEnabled = false;
  function enableDesktopSnap() {
    if (snapEnabled) {
      applyMediaHeight();
      if (hasGsap) ScrollTrigger.refresh();
      return;
    }
    applyMediaHeight();
    /* initSnaps(); */ //Commentati per il momento causavano bug nello scroll
    snapEnabled = true;
  }
  function disableDesktopSnap() {
    if (!snapEnabled) return;
    if (hasGsap) ScrollTrigger.getAll().forEach(st => {
      if (st.vars && st.vars.__snapPanel) st.kill();
    });
    snapEnabled = false;
  }

  // iniziale
  applyTopToOverlays();
  if (isDesktop()) enableDesktopSnap();

  window.addEventListener('resize', () => {
    scheduleUpdate();
    if (isDesktop()) enableDesktopSnap();
    else disableDesktopSnap();
  }, { passive: true });

  window.addEventListener('scroll', () => {
    scheduleUpdate();
  }, { passive: true });

  if (window.visualViewport) {
    visualViewport.addEventListener('resize', () => {
      scheduleUpdate();
      if (isDesktop()) enableDesktopSnap();
      else disableDesktopSnap();
    }, { passive: true });
    visualViewport.addEventListener('scroll', () => {
      scheduleUpdate();
    }, { passive: true });
  }

  // eventi Shopify
  document.addEventListener('shopify:section:load', () => {
    applyTopToOverlays();
    if (isDesktop()) enableDesktopSnap();
    else disableDesktopSnap();
  });
  document.addEventListener('shopify:section:reorder', () => {
    applyTopToOverlays();
    if (isDesktop()) enableDesktopSnap();
    else disableDesktopSnap();
  });
  window.addEventListener('pageshow', applyTopToOverlays);

  // quando si apre/chiude un <dialog> (es. search-modal)
  document.addEventListener('toggle', (evt) => {
    if (evt.target?.matches?.('dialog, dialog.search-modal, .facets--drawer.dialog-modal')) {
      scheduleUpdate();
    }
  });

  // osserva il drawer filtri e ricalcola se viene riaggiunto o gli cambiano attributi
  const overlaySelectors = '.facets--drawer.dialog-modal, dialog.search-modal__content, .account-popover__panel, [data-header-drawer], .menu-drawer__backdrop';
  const overlayObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList') {
        if ([...m.addedNodes].some(n => n.nodeType === 1 && (n.matches?.(overlaySelectors) || n.querySelector?.(overlaySelectors)))) {
          scheduleUpdate();
          break;
        }
      }
      if (m.type === 'attributes' && (m.target?.matches?.(overlaySelectors))) {
        scheduleUpdate();
        break;
      }
    }
  });
  overlayObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'open']
  });

  // hook alle variazioni di URL (pushState/replaceState/popstate) usate dai filtri
  (function (history) {
    const wrap = (type) => {
      const orig = history[type];
      return function () {
        const ret = orig.apply(this, arguments);
        window.dispatchEvent(new Event('locationchange'));
        return ret;
      };
    };
    history.pushState = wrap('pushState');
    history.replaceState = wrap('replaceState');
  })(window.history);
  window.addEventListener('popstate', () => window.dispatchEvent(new Event('locationchange')));
  window.addEventListener('locationchange', () => {
    // aspetta un frame per dare tempo al DOM di aggiornarsi
    requestAnimationFrame(applyTopToOverlays);
  });


  /* ===============================
  *  QUIZ FRAGRANZE — step + mapping + colore dinamico
  * =============================== */
  (function() {
    // esegui solo se siamo nella pagina "page.test-fragranza"
    const main = document.querySelector('main[data-template*="page.test-fragranza"]');
    if (!main) return;
    // ===== CONFIG =====
    const USE_ASSET   = true; // se leggi da Assets
    const ASSET_URL = (document.getElementById('quiz-config')?.dataset.quizUrl || '').trim();
    const RESULTS_MODE = 'redirect';
    const FALLBACK_HANDLE = 'all';
    const FALLBACK_TITLE  = 'Selezione generale';
    const LETTER_ORDER = {
      1: ['A','B','C'],
      2: ['A','B','C'],
      3: ['A','B','C'],
      4: ['A','B','C'],
      5: ['A','B','C']
    };

    // Palette provvisoria per domanda/lettera (A/B/C)
    // Scegli tu i colori (coerenti con brand/UX). Questi sono di esempio.
    const PALETTE = {
      1: { A:'#FFFDF1', B:'#FAF6F6', C:'#F6E9D6' },
      2: { A:'#F3F0ED', B:'#E9E4E1', C:'#FDF6F9' },
      3: { A:'#F9EDCF', B:'#E8EFDD', C:'#E9F5FA' },
      4: { A:'#E1E9D8', B:'#FDF6D6', C:'#F3F0ED' },
      5: { A:'#FAF4F7', B:'#FEF9E8', C:'#E7F5F0' }
    };

    // target da colorare
    const COLOR_TARGETS = [
      () => document.querySelector('.header__row'),
      () => document.querySelector('main')
    ];
    const DEFAULT_COLORS = (() => {
      const els = COLOR_TARGETS.map(get => get()).filter(Boolean);
      return els.map(el => getComputedStyle(el).backgroundColor || '');
    })();

    const BTN_SEL = {
      start:  '.quiz-start',
      prev:   '.quiz-prev',
      next:   '.quiz-next',
      finish: '.quiz-finish'
    };
    const getBtn = (stepEl, type) => stepEl.querySelector(BTN_SEL[type]);

    function resetThemeColor() {
      const els = COLOR_TARGETS.map(get => get()).filter(Boolean);
      els.forEach((el, i) => { el.style.backgroundColor = DEFAULT_COLORS[i] || ''; });
    }

    // stile base per transizioni (se non già presente)
    (function ensureQuizStyle(){
      const id = 'quiz-min-style';
      if (document.getElementById(id)) return;
      const s = document.createElement('style');
      s.id = id;
      s.textContent = `
        .risposta.is-selected p, .risposta:hover p { font-weight: 600; }
      `;
      document.head.appendChild(s);
    })();

    // ===== STATE =====
    const state = {
      stepIndex: 0,     // 0 = intro, poi 1..N domande
      answers: [],      // lettere A/B/C per domanda
      mapping: {}       // code -> {collection_handle, collection_title, color?}
    };

    // ===== UTILS =====
    const qsa = (sel, root=document) => Array.from(root.querySelectorAll(sel));
    const qs  = (sel, root=document) => root.querySelector(sel);
    const hide = el => { if (el) el.style.display = 'none'; };
    const show = el => { if (el) el.style.display = ''; };

    function collectQuizSteps() {
      const wrappers = qsa('.shopify-section.section-wrapper');
      const intro = wrappers.find(w => !w.querySelector('.section.section_to_hide'));
      const questions = wrappers.filter(w => w.querySelector('.section.section_to_hide'));
      const steps = [];
      if (intro) steps.push(intro);
      steps.push(...questions);
      return steps;
    }

    function centerSecondAnswer(stepEl) {
      const scroller =
        stepEl.querySelector('.domanda > .layout-panel-flex') ||
        stepEl.querySelector('.domanda .layout-panel-flex');
      if (!scroller) return;

      const answers = scroller.querySelectorAll('.risposta');
      const target = answers[1] || answers[0]; // prova la 2ª, fallback 1ª
      if (!target) return;

      // doppio rAF per aspettare layout/style/immagini
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
        });
      });
    }

    function setActiveStep(steps, index) {
      // mostra solo lo step attivo
      steps.forEach((el, i) => i === index ? show(el) : hide(el));

      // reset colore di default
      resetThemeColor();

      // 🔹 disabilita tab su tutte le risposte (anche quelle nascoste)
      document.querySelectorAll('.risposta').forEach(el => { el.tabIndex = -1; });

      // 🔹 abilita tab solo sulle risposte dello step corrente e focus sulla prima
      const currentAnswers = steps[index].querySelectorAll('.risposta');
      currentAnswers.forEach(el => { el.tabIndex = 0; });
      if (currentAnswers[0]) {
        currentAnswers[0].focus({ preventScroll: true });
      }

      // da Q1 in poi (index 1..5): colore e ripristino selezione
      if (index >= 1) {
        const qNum = index;
        const saved = state.answers[qNum - 1];
        if (saved) {
          const hex = PALETTE[qNum]?.[saved];
          if (hex) setThemeColor(hex);
          const ansEls = steps[index].querySelectorAll('.risposta');
          ansEls.forEach(el => el.classList.toggle('is-selected', el.dataset.answer === saved));
        }

        // centra la 2ª risposta quando entri nella domanda
        centerSecondAnswer(steps[index]);
      }
    }


    // ===== COLOR HELPERS =====
    const hexToRgb = (hex) => {
      if (!hex) return null;
      const s = hex.replace('#','').trim();
      if (![3,6].includes(s.length)) return null;
      const full = s.length === 3 ? s.split('').map(c=>c+c).join('') : s;
      const r = parseInt(full.slice(0,2),16);
      const g = parseInt(full.slice(2,4),16);
      const b = parseInt(full.slice(4,6),16);
      return [r,g,b];
    };
    const rgbToHex = ([r,g,b]) => '#' + [r,g,b].map(n => {
      const v = Math.max(0, Math.min(255, Math.round(n)));
      return v.toString(16).padStart(2,'0');
    }).join('');

    function mixRgb(colors) {
      if (!colors.length) return [255,255,255];
      const acc = colors.reduce((a,c) => [a[0]+c[0], a[1]+c[1], a[2]+c[2]], [0,0,0]);
      return [ acc[0]/colors.length, acc[1]/colors.length, acc[2]/colors.length ];
    }

    // colore “provvisorio” in base alle risposte date finora (media dei colori scelti)
    function computeProvisionalColor() {
      const rgbs = [];
      state.answers.forEach((letter, i) => {
        const qn = i+1;
        const hex = PALETTE[qn]?.[letter];
        const rgb = hexToRgb(hex);
        if (rgb) rgbs.push(rgb);
      });
      const mixed = mixRgb(rgbs);
      return rgbToHex(mixed);
    }

    function setThemeColor(hex) {
      // usa GSAP se c'è, altrimenti fallback direttamente
      const targets = COLOR_TARGETS.map(get => get()).filter(Boolean);
      if (!targets.length) return;

      if (window.gsap) {
        targets.forEach(el => {
          gsap.to(el, { backgroundColor: hex, duration: 0.45, ease: 'power2.out' });
        });
      } else {
        targets.forEach(el => el.style.backgroundColor = hex);
      }
    }

    // ===== QUIZ LOGIC =====
    function attachAnswers(stepEl, stepNumber) {
      const answers = qsa('.risposta', stepEl);
      if (!answers.length) return;

      const nextInit = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
      if (nextInit) nextInit.classList.add('is-disabled');

      answers.forEach((ansEl, i) => {
        const order  = LETTER_ORDER[stepNumber] || ['A','B','C'];
        const letter = order[i] || 'A';

        ansEl.dataset.answer = letter;
        ansEl.setAttribute('role','button');
        ansEl.tabIndex = -1;

        const mark = () => {
          // reset classi visive
          answers.forEach(a => {
            a.classList.remove('is-selected', 'dimmed');
            a.style.opacity = ''; // reset
          });

          // seleziona quella cliccata
          ansEl.classList.add('is-selected');

          // tutte le altre diventano dimmed
          answers.forEach(a => {
            if (a !== ansEl) {
              a.classList.add('dimmed');
              a.style.opacity = '0.2';
            }
          });

          // salva risposta
          state.answers[stepNumber - 1] = letter;

          const nextBtn = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
          if (nextBtn) nextBtn.classList.remove('is-disabled');

          const hex = PALETTE[stepNumber] && PALETTE[stepNumber][letter];
          if (hex) setThemeColor(hex);
        };

        ansEl.addEventListener('click', mark);
        ansEl.addEventListener('keydown', ev => {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); mark(); }
        });
      });
    }

    function buildCode() {
      if (!state.answers.length) return null;
      if (state.answers.some(a => !a)) return null;
      return state.answers.join('');
    }

    function goResults(code) {
      const hit = state.mapping[code];

      if (!hit && !FALLBACK_HANDLE) {
        alert('Combinazione non trovata. Riprova o contattaci.');
        return;
      }
      const handle = (hit && hit.collection_handle) || FALLBACK_HANDLE;
      const title  = (hit && hit.collection_title)  || FALLBACK_TITLE;

      if (RESULTS_MODE === 'redirect') {
        window.location.href = '/collections/' + handle;
        return;
      }
    }

    async function loadMapping() {
      try {
        if (USE_ASSET) {
          if (!ASSET_URL) throw new Error('Asset URL mancante: aggiungi il #quiz-config con data-quiz-url');
          const r = await fetch(ASSET_URL, { credentials: 'same-origin', cache: 'no-store' });
          if (!r.ok) throw new Error(`Fetch fallita: ${r.status} ${r.statusText}`);
          const data = await r.json();
          const m = data?.mapping || data;
          state.mapping = (m && typeof m === 'object') ? m : {};
        } else {
          const raw = document.getElementById('quiz-data')?.textContent || '{}';
          const data = JSON.parse(raw);
          const m = data?.mapping || data;
          state.mapping = (m && typeof m === 'object') ? m : {};
        }
      } catch(e) {
        console.warn('Quiz mapping non disponibile', e);
        state.mapping = {};
      }
    }

    // ===== INIT =====
    (async function initQuiz(){
      const steps = collectQuizSteps();
      if (!steps.length) return;

      state.stepIndex = 0; // mostra intro
      setActiveStep(steps, state.stepIndex);

      steps.forEach((stepEl, i) => {
        const start = getBtn(stepEl, 'start');
        if (start) start.addEventListener('click', (ev) => {
          ev.preventDefault();
          state.stepIndex = Math.min(1, steps.length - 1);
          setActiveStep(steps, state.stepIndex);
        });

        const prev = getBtn(stepEl, 'prev');
        if (prev) prev.addEventListener('click', (ev) => {
          ev.preventDefault();
          state.stepIndex = Math.max(0, state.stepIndex - 1);
          setActiveStep(steps, state.stepIndex);
        });

        // continua o scopri i risultati (multilingua-safe, solo classi)
        const nextOrFinish = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
        if (nextOrFinish) nextOrFinish.addEventListener('click', (ev) => {
          ev.preventDefault();

          const isQuestionStep = !!stepEl.querySelector('.domanda') || !!stepEl.querySelector('.risposta');
          if (isQuestionStep) {
            const questionNumber = i; // intro = 0 → Q1 = 1
            const ans = state.answers[questionNumber - 1];
            if (!ans) { alert('Seleziona una risposta per continuare.'); return; }
          }

          const lastIndex   = steps.length - 1;
          const isFinishBtn = nextOrFinish.matches(BTN_SEL.finish);
          const isLastStep  = i >= lastIndex;

          if (isFinishBtn || isLastStep) {
            const code = buildCode();
            if (!code) { alert('Risposte incomplete.'); return; }
            goResults(code);
            return;
          }

          state.stepIndex = i + 1;
          setActiveStep(steps, state.stepIndex);
        });

        const isQuestionStep = !!stepEl.querySelector('.domanda') || !!stepEl.querySelector('.risposta');
        if (isQuestionStep) attachAnswers(stepEl, i); // i=1..N (intro=0)
      });

      await loadMapping();
    })();
  })();

  /* ===============================
  *  QUIZ FRAGRANZE — per negozio fisico
  * =============================== */
  (function() {
    const main = document.querySelector('main[data-template*="page.quiz-negozio"]');
    if (!main) return;

    // ===== CONFIG =====
    const USE_ASSET       = true;
    const ASSET_URL       = (document.getElementById('quiz-config')?.dataset.quizUrl || '').trim();
    const FALLBACK_HANDLE = 'all';
    const FALLBACK_TITLE  = 'Selezione generale';

    const LETTER_ORDER = {
      1: ['A','B','C'],
      2: ['A','B','C'],
      3: ['A','B','C'],
      4: ['A','B','C'],
      5: ['A','B','C']
    };

    const PALETTE = {
      1: { A:'#FFFDF1', B:'#FAF6F6', C:'#F6E9D6' },
      2: { A:'#F3F0ED', B:'#E9E4E1', C:'#FDF6F9' },
      3: { A:'#F9EDCF', B:'#E8EFDD', C:'#E9F5FA' },
      4: { A:'#E1E9D8', B:'#FDF6D6', C:'#F3F0ED' },
      5: { A:'#FAF4F7', B:'#FEF9E8', C:'#E7F5F0' }
    };

    const COLOR_TARGETS = [
      () => document.querySelector('.header__row'),
      () => document.querySelector('main')
    ];
    const DEFAULT_COLORS = (() => {
      const els = COLOR_TARGETS.map(get => get()).filter(Boolean);
      return els.map(el => getComputedStyle(el).backgroundColor || '');
    })();

    const BTN_SEL = {
      start:  '.quiz-start',
      prev:   '.quiz-prev',
      next:   '.quiz-next',
      finish: '.quiz-finish'
    };
    const getBtn = (stepEl, type) => stepEl.querySelector(BTN_SEL[type]);

    function resetThemeColor() {
      const els = COLOR_TARGETS.map(get => get()).filter(Boolean);
      els.forEach((el, i) => { el.style.backgroundColor = DEFAULT_COLORS[i] || ''; });
    }

    (function ensureQuizStyle(){
      const id = 'quiz-min-style';
      if (document.getElementById(id)) return;
      const s = document.createElement('style');
      s.id = id;
      s.textContent = `.risposta.is-selected p, .risposta:hover p { font-weight: 600; }`;
      document.head.appendChild(s);
    })();

    // ===== STATE =====
    const state = {
      stepIndex:      0,
      answers:        [],
      mapping:        {},
      steps:          [],
      resultsWrapper: null
    };

    // ===== UTILS =====
    const qsa  = (sel, root=document) => Array.from(root.querySelectorAll(sel));
    const hide = el => { if (el) el.style.display = 'none'; };
    const show = el => { if (el) el.style.display = ''; };

    // ===== COLLECT STEPS =====
    function collectQuizSteps() {
      const wrappers       = qsa('.shopify-section.section-wrapper');
      const intro          = wrappers.find(w => !w.querySelector('.section.section_to_hide'));
      const allHidden      = wrappers.filter(w => w.querySelector('.section.section_to_hide'));
      const resultsWrapper = allHidden.find(w => w.querySelector('.results_section')) || null;
      const questions      = allHidden.filter(w => !w.querySelector('.results_section'));
      const steps = [];
      if (intro) steps.push(intro);
      steps.push(...questions);
      return { steps, resultsWrapper };
    }

    function centerSecondAnswer(stepEl) {
      const scroller =
        stepEl.querySelector('.domanda > .layout-panel-flex') ||
        stepEl.querySelector('.domanda .layout-panel-flex');
      if (!scroller) return;
      const answers = scroller.querySelectorAll('.risposta');
      const target  = answers[1] || answers[0];
      if (!target) return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
        });
      });
    }

    function setActiveStep(steps, index) {
      steps.forEach((el, i) => i === index ? show(el) : hide(el));
      resetThemeColor();

      document.querySelectorAll('.risposta').forEach(el => { el.tabIndex = -1; });
      const currentAnswers = steps[index].querySelectorAll('.risposta');
      currentAnswers.forEach(el => { el.tabIndex = 0; });
      if (currentAnswers[0]) currentAnswers[0].focus({ preventScroll: true });

      if (index >= 1) {
        const saved = state.answers[index - 1];
        if (saved) {
          const hex = PALETTE[index]?.[saved];
          if (hex) setThemeColor(hex);
          const ansEls = steps[index].querySelectorAll('.risposta');
          ansEls.forEach(el => el.classList.toggle('is-selected', el.dataset.answer === saved));
        }
        centerSecondAnswer(steps[index]);
      }
    }

    // ===== COLOR HELPERS =====
    const hexToRgb = (hex) => {
      if (!hex) return null;
      const s    = hex.replace('#','').trim();
      if (![3,6].includes(s.length)) return null;
      const full = s.length === 3 ? s.split('').map(c=>c+c).join('') : s;
      return [
        parseInt(full.slice(0,2),16),
        parseInt(full.slice(2,4),16),
        parseInt(full.slice(4,6),16)
      ];
    };
    const rgbToHex = ([r,g,b]) => '#' + [r,g,b].map(n => {
      return Math.max(0,Math.min(255,Math.round(n))).toString(16).padStart(2,'0');
    }).join('');

    function mixRgb(colors) {
      if (!colors.length) return [255,255,255];
      const acc = colors.reduce((a,c) => [a[0]+c[0], a[1]+c[1], a[2]+c[2]], [0,0,0]);
      return [ acc[0]/colors.length, acc[1]/colors.length, acc[2]/colors.length ];
    }

    function computeProvisionalColor() {
      const rgbs = [];
      state.answers.forEach((letter, i) => {
        const hex = PALETTE[i+1]?.[letter];
        const rgb = hexToRgb(hex);
        if (rgb) rgbs.push(rgb);
      });
      return rgbToHex(mixRgb(rgbs));
    }

    function setThemeColor(hex) {
      const targets = COLOR_TARGETS.map(get => get()).filter(Boolean);
      if (!targets.length) return;
      if (window.gsap) {
        targets.forEach(el => gsap.to(el, { backgroundColor: hex, duration: 0.45, ease: 'power2.out' }));
      } else {
        targets.forEach(el => el.style.backgroundColor = hex);
      }
    }

    // ===== QUIZ LOGIC =====
    function attachAnswers(stepEl, stepNumber) {
      const answers = qsa('.risposta', stepEl);
      if (!answers.length) return;

      const nextInit = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
      if (nextInit) nextInit.classList.add('is-disabled');

      answers.forEach((ansEl, i) => {
        const order  = LETTER_ORDER[stepNumber] || ['A','B','C'];
        const letter = order[i] || 'A';

        ansEl.dataset.answer = letter;
        ansEl.setAttribute('role','button');
        ansEl.tabIndex = -1;

        const mark = () => {
          answers.forEach(a => {
            a.classList.remove('is-selected','dimmed');
            a.style.opacity = '';
          });
          ansEl.classList.add('is-selected');
          answers.forEach(a => {
            if (a !== ansEl) { a.classList.add('dimmed'); a.style.opacity = '0.2'; }
          });

          state.answers[stepNumber - 1] = letter;

          const nextBtn = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
          if (nextBtn) nextBtn.classList.remove('is-disabled');

          const hex = PALETTE[stepNumber]?.[letter];
          if (hex) setThemeColor(hex);
        };

        ansEl.addEventListener('click', mark);
        ansEl.addEventListener('keydown', ev => {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); mark(); }
        });
      });
    }

    function buildCode() {
      if (!state.answers.length) return null;
      if (state.answers.some(a => !a)) return null;
      return state.answers.join('');
    }

    // ===== COLLECTIONS DATA =====
    function loadCollectionsData() {
      try {
        const raw = document.getElementById('quiz-collections-data')?.textContent || '{}';
        return JSON.parse(raw);
      } catch(e) {
        console.warn('Quiz: errore parsing collections data', e);
        return {};
      }
    }

    // ===== MEDIA RENDER (immagini_o_video_per_bolle) =====
    function renderMedia(container, files) {
      container.innerHTML = '';

      files.forEach((item, index) => {
        const src  = typeof item === 'string' ? item : item.url;
        const type = typeof item === 'string'
          ? (/\.(mp4|webm|ogg|mov)/i.test(src) ? 'video' : 'image')
          : item.type;

        if (!src) return;
        const fullSrc = src.startsWith('//') ? 'https:' + src : src;
        const n = index + 1; // posizione globale: 1, 2, 3, 4...

        if (type === 'video') {
          const video = document.createElement('video');
          video.className   = `media-item video_${n} floating_bubble bubble-revealed bubble-floating`;
          video.src         = fullSrc;
          video.autoplay    = true;
          video.muted       = true;
          video.loop        = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          container.appendChild(video);

        } else {
          const img = document.createElement('img');
          img.className = `media-item image_${n} floating_bubble bubble-revealed bubble-floating`;
          img.src       = fullSrc;
          img.alt       = '';
          img.loading   = 'lazy';
          container.appendChild(img);
        }
      });
    }

    // ===== RESULTS =====
    function goResults(code) {
      const hit = state.mapping[code];
      if (!hit && !FALLBACK_HANDLE) { alert('Combinazione non trovata.'); return; }

      const base = hit || {
        collection_handle: FALLBACK_HANDLE,
        collection_title:  FALLBACK_TITLE
      };

      const rw = state.resultsWrapper;
      if (!rw) { console.warn('Quiz: .results_section non trovata'); return; }

      const allCollections = loadCollectionsData();
      const liquidData     = allCollections[base.collection_handle] || {};
      const collection     = { ...base, ...liquidData };

      state.currentCollection = collection;

      const imageField = rw.querySelector('[data-collection-field="image"]');
      if (imageField) {
        imageField.classList.remove('is-ready');
      }

      rw.querySelectorAll('[data-collection-field]').forEach(el => {
        const key = el.dataset.collectionField;
        const val = collection[key];
        if (val === undefined || val === null || val === '') return;

        if (el.tagName === 'A') {
          el.href = '/collections/' + collection.collection_handle;
        } else if (key === 'image') {
          const imageWrapper = el.matches('[data-collection-field="image"]')
            ? el
            : el.closest('[data-collection-field="image"]');

          const img = el.tagName === 'IMG' ? el : el.querySelector('img');

          if (img) {
            const finalSrc = val.startsWith('http') ? val : 'https:' + val;

            if (imageWrapper) {
              imageWrapper.classList.remove('is-ready');
            }

            const revealImage = () => {
              if (imageWrapper) {
                imageWrapper.classList.add('is-ready');
              }
              img.onload = null;
              img.onerror = null;
            };

            img.onload = revealImage;
            img.onerror = revealImage;

            img.removeAttribute('srcset');

            if (img.src === finalSrc) {
              revealImage();
            } else {
              img.src = finalSrc;
            }
          }
        } else if ('html' in el.dataset) {
          el.innerHTML = val;
        } else {
          el.textContent = val;
        }
      });

      const mediaContainer = rw.querySelector('[data-media-gallery]');
      if (mediaContainer) {
        const raw = collection['immagini_o_video_per_bolle'];
        const files = Array.isArray(raw)
          ? raw
          : (raw ? String(raw).split(',').map(s => s.trim()).filter(Boolean) : []);

        if (files.length) {
          renderMedia(mediaContainer, files);
        } else {
          mediaContainer.innerHTML = '';
        }
      }

      state.steps.forEach(hide);

      const finalColor = collection.colore || computeProvisionalColor();
      if (finalColor) setThemeColor(finalColor);

      show(rw);
      rw.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ===== MAPPING =====
    async function loadMapping() {
      try {
        if (USE_ASSET) {
          if (!ASSET_URL) throw new Error('Asset URL mancante: aggiungi il #quiz-config con data-quiz-url');
          const r = await fetch(ASSET_URL, { credentials: 'same-origin', cache: 'no-store' });
          if (!r.ok) throw new Error(`Fetch fallita: ${r.status} ${r.statusText}`);
          const data = await r.json();
          const m = data?.mapping || data;
          state.mapping = (m && typeof m === 'object') ? m : {};
        } else {
          const raw  = document.getElementById('quiz-data')?.textContent || '{}';
          const data = JSON.parse(raw);
          const m    = data?.mapping || data;
          state.mapping = (m && typeof m === 'object') ? m : {};
        }
      } catch(e) {
        console.warn('Quiz mapping non disponibile', e);
        state.mapping = {};
      }
    }

    function resetQuiz() {
      state.answers = [];
      state.stepIndex = 0;

      resetThemeColor();

      document.querySelectorAll('.risposta').forEach(el => {
        el.classList.remove('is-selected', 'dimmed');
        el.style.opacity = '';
      });

      state.steps.forEach(stepEl => {
        const btn = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
        if (btn) btn.classList.add('is-disabled');
      });

      if (state.resultsWrapper) hide(state.resultsWrapper);

      setActiveStep(state.steps, 0);
    }

    // ===== INIT =====
    (async function initQuiz(){
      const { steps, resultsWrapper } = collectQuizSteps();
      if (!steps.length) return;

      state.steps          = steps;
      state.resultsWrapper = resultsWrapper;

      if (resultsWrapper) hide(resultsWrapper);

      state.stepIndex = 0;
      setActiveStep(steps, state.stepIndex);

      steps.forEach((stepEl, i) => {

        const start = getBtn(stepEl, 'start');
        if (start) start.addEventListener('click', ev => {
          ev.preventDefault();
          state.stepIndex = Math.min(1, steps.length - 1);
          setActiveStep(steps, state.stepIndex);
        });

        const prev = getBtn(stepEl, 'prev');
        if (prev) prev.addEventListener('click', ev => {
          ev.preventDefault();

          const nextIndex = Math.max(0, state.stepIndex - 1);

          if (nextIndex === 0) {
            resetQuiz();
            return;
          }

          state.stepIndex = nextIndex;
          setActiveStep(steps, state.stepIndex);
        });

        const nextOrFinish = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
        if (nextOrFinish) nextOrFinish.addEventListener('click', ev => {
          ev.preventDefault();

          const isQuestionStep = !!stepEl.querySelector('.domanda') || !!stepEl.querySelector('.risposta');
          if (isQuestionStep) {
            const ans = state.answers[i - 1];
            if (!ans) { alert('Seleziona una risposta per continuare.'); return; }
          }

          const lastIndex   = steps.length - 1;
          const isFinishBtn = nextOrFinish.matches(BTN_SEL.finish);
          const isLastStep  = i >= lastIndex;

          if (isFinishBtn || isLastStep) {
            const code = buildCode();
            if (!code) { alert('Risposte incomplete.'); return; }
            goResults(code);
            return;
          }

          state.stepIndex = i + 1;
          setActiveStep(steps, state.stepIndex);
        });

        const isQuestionStep = !!stepEl.querySelector('.domanda') || !!stepEl.querySelector('.risposta');
        if (isQuestionStep) attachAnswers(stepEl, i);
      });

      if (resultsWrapper) {
        const repeatBtn = resultsWrapper.querySelector('.repeat_test');
        if (repeatBtn) repeatBtn.addEventListener('click', ev => {
          ev.preventDefault();
          state.answers   = [];
          state.stepIndex = 0;
          hide(resultsWrapper);
          resetThemeColor();

          document.querySelectorAll('.risposta').forEach(el => {
            el.classList.remove('is-selected', 'dimmed');
            el.style.opacity = '';
          });

          steps.forEach(stepEl => {
            const btn = getBtn(stepEl, 'next') || getBtn(stepEl, 'finish');
            if (btn) btn.classList.add('is-disabled');
          });

          setActiveStep(steps, 0);
        });
      }

      document.querySelectorAll('.quiz-restart').forEach(btn => {
        btn.addEventListener('click', ev => {
          ev.preventDefault();
          resetQuiz();
        });
      });

      await loadMapping();
    })();

  })();

  // ==========================================
  // BUBBLES + MULTI-GROUP TEXT/BUTTON ANIMATIONS
  // robusto + partial wait + multi-sezione (Shopify) — citazione uniformata
  // ==========================================

  const BUBBLE_REVEAL_STAGGER   = 250;  // ms tra rivelazioni bolla
  const BUBBLE_REVEAL_DURATION  = 1000;  // ms durata bubbleReveal (0.6s)
  const TEXT_STAGGER_DEFAULT    = 100;  // ms tra elementi del gruppo
  const SAFETY_EXTRA_MS         = 300;  // margine fallback
  const SEQ_STEP_GAP            = 140;  // ms tra gli step delle sequenze custom

  // soglia PARZIALE: fai partire i testi quando è rivelata questa quota
  const MIN_REVEALED_FOR_TEXT     = 0;    // almeno N bolle
  const PERCENT_REVEALED_FOR_TEXT = 0;  // oppure % bolle (0..1)

  const animatedSections = new Set();

  // Gruppi generici (supporto underscore e dash)
  // NOTA: citazione ora è gestita come un gruppo normale, niente .animate-in speciale
  const GROUPS = [
    { name: 'heroLines', selector: '.citazione-hero p, .citazione_hero p', usesCssClass: false, stagger: 100 },
    { name: 'titles',    selector: '.title_animation, .title-animation',   usesCssClass: false, stagger: 90  },
    { name: 'paras',     selector: '.paragraph_animation, .paragraph-animation', usesCssClass: false, stagger: 80  },
    { name: 'buttons',   selector: '.button_animation, .button-animation, .cta, .button:not(.deferred-media__poster-button), a[class*="button"], [class*="btn"]', usesCssClass: false, stagger: 70 },
  ];

  /* =============== UTIL =============== */

  function qsa(scope, sel) { return Array.from(scope.querySelectorAll(sel)); }

  function waitForPartialBubbleReveals(bubbles, perBubbleStagger = BUBBLE_REVEAL_STAGGER, revealDuration = BUBBLE_REVEAL_DURATION) {
    if (!bubbles || bubbles.length === 0) return Promise.resolve();

    const total = bubbles.length;
    const targetCount = Math.min(total, Math.max(MIN_REVEALED_FOR_TEXT, Math.ceil(total * PERCENT_REVEALED_FOR_TEXT)));
    const idxTarget   = Math.max(0, targetCount - 1);
    const theoretical = idxTarget * perBubbleStagger + revealDuration + SAFETY_EXTRA_MS;

    let resolved = false;
    let revealedCount = 0;

    return new Promise(resolve => {
      const done = () => { if (!resolved) { resolved = true; resolve(); } };
      const fallback = setTimeout(done, theoretical);

      const onAnimEnd = (ev) => {
        if (ev.animationName !== 'bubbleReveal') return;
        revealedCount += 1;
        if (revealedCount >= targetCount) {
          clearTimeout(fallback);
          bubbles.forEach(b => b.removeEventListener('animationend', onAnimEnd));
          done();
        }
      };

      bubbles.forEach(bubble => bubble.addEventListener('animationend', onAnimEnd));
    });
  }

  function prepareInitialStateFor(el) {
    if (el.dataset.prepared === '1') return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 500ms ease-in-out, transform 500ms ease-in-out';
    el.dataset.prepared = '1';
  }

  function triggerIn(el, delayMs) {
    if (el.dataset.animated === '1') return;
    el.style.transitionDelay = `${delayMs}ms`;
    requestAnimationFrame(() => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
      el.dataset.animated = '1';
    });
  }

  /* =============== PREP =============== */

  function prepareGroups(container) {
    GROUPS.forEach(group => {
      qsa(container, group.selector).forEach(prepareInitialStateFor);
    });
  }

  function prepareGlobalIfEmpty(container) {
    let found = 0;
    GROUPS.forEach(group => { found += qsa(container, group.selector).length; });
    if (found > 0) return;
    GROUPS.forEach(group => { qsa(document, group.selector).forEach(prepareInitialStateFor); });
  }

  /* =============== ANIMATE (generico) =============== */

  function animateGroup(containerOrDoc, selector, stagger = TEXT_STAGGER_DEFAULT) {
    const els = qsa(containerOrDoc, selector).filter(el => el.dataset.animated !== '1');
    if (els.length === 0) return;
    els.forEach((el, i) => triggerIn(el, i * stagger));
  }

  function animateTextGroups(container) {
    // Prima nel container
    GROUPS.forEach(group => {
      animateGroup(container, group.selector, group.stagger);
    });

    // Se non c'era nulla nel container, prova globale
    const anyInContainer = GROUPS.some(g => qsa(container, g.selector).length > 0);
    if (!anyInContainer) {
      GROUPS.forEach(group => {
        animateGroup(document, group.selector, group.stagger);
      });
    }
  }

  /* =============== SEQUENZE CUSTOM PER SHOPIFY =============== */

  // Mappa classi → tipo sequenza
  function getSeqForContainer(container) {
    if (!container) return null;
    const cl = container.classList;
    if (cl.contains('bg-media-home-section') && cl.contains('container_bubble')) return 'hero';
    if (cl.contains('sezione_custom')      && cl.contains('container_bubble')) return 'test';
    return null;
  }

  // Prepara target specifici delle due sequenze
  function prepareSequenceTargets(container) {
    const seq = getSeqForContainer(container);
    if (!seq) return;

    const selBySeq = {
      hero: [
        '.citazione-hero p, .citazione_hero p', // righe citazione (dash e underscore)
        '.button_citazione'                     // bottone citazione
      ],
      test: [
        '.titolo_test_fragranza.intestazione',
        '.testo_test_fragranza',
        '.button_test_fragranza'
      ]
    };

    (selBySeq[seq] || []).forEach(sel => {
      qsa(container, sel).forEach(prepareInitialStateFor);
    });
  }

  // Sequenza custom dopo le bolle (parziale) — tutto tramite animateGroup
  function animateCustomSequence(container) {
    const seq = getSeqForContainer(container);
    if (!seq) return;

    if (seq === 'hero') {
      // 1) citazione (righe p con leggero stagger)
      animateGroup(container, '.citazione-hero p, .citazione_hero p', 100);

      // 2) poco dopo → bottone citazione
      setTimeout(() => {
        animateGroup(container, '.button_citazione', 0);
      }, SEQ_STEP_GAP);

      return;
    }

    if (seq === 'test') {
      // 1) titolo
      animateGroup(container, '.titolo_test_fragranza', 0);

      // 2) poco dopo → testo
      setTimeout(() => {
        animateGroup(container, '.testo_test_fragranza', 0);
      }, SEQ_STEP_GAP);

      // 3) poco dopo → bottone
      setTimeout(() => {
        animateGroup(container, '.button_test_fragranza', 0);
      }, SEQ_STEP_GAP * 2);

      return;
    }
  }

  // Override gentile: se il container è uno dei due, usa la sequenza custom
  const _animateTextGroups_original = animateTextGroups;
  animateTextGroups = function(container) {
    if (getSeqForContainer(container)) {
      animateCustomSequence(container);
      return;
    }
    _animateTextGroups_original(container);
  };

  /* =============== BUBBLES SEQUENCE =============== */

  function animateBubbleSection(container) {
    // prepara gli elementi del container
    prepareGroups(container);
    // + prep extra per target custom (evita FOUC anche sui target di sequenza)
    prepareSequenceTargets(container);

    const bubbles = qsa(container, '.floating_bubble');

    // fallback: se nel container non c'è niente (solo bolle altrove, o elementi fuori)
    prepareGlobalIfEmpty(container);

    // no bolle → anima subito i contenuti (o la sequenza custom)
    if (bubbles.length === 0) {
      animateTextGroups(container);
      return;
    }

    // partial wait
    const partialReady = waitForPartialBubbleReveals(bubbles);

    // Phase 1: reveal (stagger)
    bubbles.forEach((bubble, index) => {
      const baseDelay = index * BUBBLE_REVEAL_STAGGER;
      const jitter    = Math.random() * 90;              // micro-variazione
      const revDur    = 850 + Math.random() * 450;       // 0.85s–1.3s
      const revDelay  = baseDelay + jitter;
      const floatDelay = revDelay + revDur - 50;         // fa partire il float a reveal quasi finito

      bubble.style.setProperty('--rev-duration', `${revDur}ms`);
      bubble.style.setProperty('--rev-delay',    `${revDelay}ms`);
      bubble.style.setProperty('--float-delay',  `${floatDelay}ms`);

      // aggiungo le classi subito: i delay li governa il CSS via var()
      bubble.classList.add('bubble-revealed');
      // il float scatterà dopo --float-delay, niente requestAnimationFrame qui
      bubble.classList.add('bubble-floating');
    });

    // Quando raggiungo la soglia → avvio gruppi / sequenza custom
    partialReady.then(() => {
      animateTextGroups(container);
    });
  }

  /* =============== IO + INIT =============== */

  function initBubbleSystem() {
    const containers = document.querySelectorAll('.container_bubble');
    if (containers.length === 0) return;

    // Prepara subito gli stati iniziali per evitare FOUC sul primo paint
    containers.forEach(c => {
      prepareGroups(c);
      prepareSequenceTargets(c); // anche i target custom
    });
    // Fallback globale per eventuali elementi fuori container
    prepareGlobalIfEmpty(document);

    if (!('IntersectionObserver' in window)) {
      containers.forEach(c => {
        if (!animatedSections.has(c)) {
          animatedSections.add(c);
          animateBubbleSection(c);
        }
      });
      return;
    }

    containers.forEach(container => {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !animatedSections.has(container)) {
            animatedSections.add(container);
            animateBubbleSection(container);
            io.unobserve(container);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });

      io.observe(container);
    });
  }

  /* =============== Videos =============== */

  function setupVideos() {
    const deferredMediaElements = document.querySelectorAll('deferred-media');
    if (deferredMediaElements.length === 0) return;

    deferredMediaElements.forEach((deferredMedia) => {
      const posterButton = deferredMedia.querySelector('.deferred-media__poster-button');
      const video = deferredMedia.querySelector('video');
      if (!(posterButton && video)) return;

      posterButton.style.display = 'none';
      video.style.display = 'block';

      ['muted', 'autoplay', 'loop', 'playsinline'].forEach(attr => video.setAttribute(attr, ''));
      video.removeAttribute('controls');

      const playVideo = () => video.play().catch(e => console.log('Autoplay prevented:', e.name));
      if (video.readyState >= 2) playVideo();
      else video.addEventListener('loadeddata', playVideo, { once: true });
    });
  }

  /* =============== Init =============== */

  requestAnimationFrame(() => {
    setupVideos();
    initBubbleSystem();
  });

  // API pubblica per rianimare (es. on section reload Shopify)
  window.reinitBubbles = () => {
    animatedSections.clear();
    initBubbleSystem();
  };

  /* Card prodotto e collezioni con funziona tab */
  document.querySelectorAll('.collection-card, .product-card').forEach((card) => {
    const outerLink = card.querySelector('.collection-card__link, .product-card__link');
    if (!outerLink) return;

    // trova CTA interne (link o bottoni) che non siano l’overlay della card
    const innerCtas = card.querySelectorAll('a.link, a.button, button.link, button.button');
    innerCtas.forEach((cta) => {
      if (cta === outerLink) return;

      // escludi dal tab order e dagli screen reader
      cta.setAttribute('tabindex', '-1');
      cta.setAttribute('aria-hidden', 'true');
      cta.setAttribute('role', 'presentation');

      // click → sempre sul link della card
      cta.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        outerLink.click();
      });

      // enter/space da tastiera → sempre sul link della card
      cta.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          outerLink.click();
        }
      });
    });
  });

  document.querySelectorAll('.card-gallery').forEach(el => {
    el.addEventListener('click', e => e.stopPropagation());
  });
  const arrows = document.querySelectorAll(
    '.product-card .slideshow-control--next, .product-card .slideshow-control--previous'
  );
  arrows.forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
    }, true);

    btn.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.stopPropagation();
      }
    }, true);
  });
  
  /* Personalizzazione prodotto — tramite varianti */
  /* (function () {
    const openBtn  = document.getElementById('open-personalizer');
    const editBtn  = document.getElementById('edit-personalizer');
    const summary  = document.getElementById('pers-summary');
    const modal    = document.getElementById('personalizer');
    if (!modal || !openBtn || !summary) return;

    const root       = openBtn.closest('.product-form-buttons');
    const pfc        = root.closest('product-form-component');
    const productUrl = pfc?.dataset?.productUrl || window.location.pathname;
    const productId  = pfc?.dataset?.productId || pfc?.getAttribute('data-product-id') || null;

    const VAL = {
      no:     root.dataset.persValueNo     || 'No',
      bottle: root.dataset.persValueBottle || 'Bottle',
      stick:  root.dataset.persValueStick  || 'Sticks',
      both:   root.dataset.persValueBoth   || 'Both',
    };

    // ----- Elements modale
    const backdrop   = modal.querySelector('.PersonalizerModal__backdrop');
    const closeBtns  = modal.querySelectorAll('[data-close]');
    const step1      = modal.querySelector('.Step[data-step-index="1"]');
    const step2      = modal.querySelector('.Step[data-step-index="2"]');
    const tabs       = modal.querySelectorAll('.PersTab');

    const previewImg  = modal.querySelector('#preview-image');
    const previewText = modal.querySelector('#preview-text');

    const bottleInput       = modal.querySelector('#bottle-text');
    const bottleCount       = modal.querySelector('#bottle-count');
    const bottleCountInline = modal.querySelector('#bottle-count-inline');

    const stickInput        = modal.querySelector('#stick-text');
    const stickCount        = modal.querySelector('#stick-count');
    const stickCountInline  = modal.querySelector('#stick-count-inline');

    // Summary in PDP
    const bottleRow = document.getElementById('summary-bottle-row');
    const stickRow  = document.getElementById('summary-stick-row');
    const bottleOut = document.getElementById('summary-bottle');
    const stickOut  = document.getElementById('summary-stick');

    // Footer modale
    const footerExtra = modal.querySelector('#pers-extra');
    const footerTotal = modal.querySelector('#pers-total');

    // Anteprime
    const previewBottleSrc = modal.dataset.previewBottleSrc || '';
    const previewStickSrc  = modal.dataset.previewStickSrc  || '';

    // Stato
    let currentStep = 1;
    const norm = (s) => String(s || '').trim().toLowerCase();

    // ===== Helpers PDP (prezzo + nota) =====
    function getPriceContainer() {
      const c1 = document.querySelector('[ref="priceContainer"]');
      if (c1) return c1;
      return document.querySelector('.product-price, .price, [data-price-container]') || null;
    }
    function getPersNoteEls() {
      const container = getPriceContainer() || document;
      const note = container.querySelector('#pers-note') || document.getElementById('pers-note');
      const amt  = container.querySelector('#pers-note-amount') || document.getElementById('pers-note-amount');
      return { note, amt };
    }

    function bindMaxLenMessageFor(inputEl) {
      if (!inputEl) return;
      const field = inputEl.closest('.Field');
      const msgEl = field ? field.querySelector('.MaxCharsMsg') : null;
      if (!msgEl) return;

      const update = () => {
        const count = getCharCount(inputEl.value);
        const max = Number(inputEl.getAttribute('maxlength') || 0);
        const show = max > 0 && count >= max;
        msgEl.hidden = !show;
      };

      inputEl.addEventListener('input', update);
      update();
    }

    // ----- Money
    function formatMoney(cents) {
      const moneyFormat = root?.dataset.moneyFormat || '';
      try {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney && moneyFormat) {
          return Shopify.formatMoney(Math.round(cents), moneyFormat);
        }
      } catch {}
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root?.dataset.currency || 'EUR'
      }).format(Math.round(cents) / 100);
    }

    // ----- Variant id corrente
    function getVariantInput() {
      return pfc?.querySelector('input[ref="variantId"]') || null;
    }

    function getCurrentVariantId() {
      const v = Number(getVariantInput()?.value);
      return Number.isFinite(v) && v > 0 ? v : null;
    }

    // ----- variant-picker container (per trovare fieldset dei radio)
    function getVariantPickerEl() {
      const all = Array.from(document.querySelectorAll('variant-picker'));

      if (productId) {
        const byId = all.find(vp => vp.dataset.productId === String(productId));
        if (byId) return byId;
      }

      const urlBare = (productUrl || '').split('?')[0];
      if (urlBare) {
        const byUrl = all.find(vp => (vp.dataset.productUrl || '').split('?')[0] === urlBare);
        if (byUrl) return byUrl;
      }

      return all[0] || null;
    }

    function getVariantPickerContainer() {
      const vp = getVariantPickerEl();
      if (!vp) return null;
      return vp.querySelector('form.variant-picker__form') || vp;
    }

    // ===== PRODUCT JSON & OPTION INDEX
    let productJson = null;
    let persOptionIndex = -1;
    let persOptionIndexFromDom = -1;

    function detectPersIndexFromDom(fs) {
      const any = fs?.querySelector('input[type="radio"][data-input-id]');
      if (!any) return -1;
      const pos = parseInt(String(any.dataset.inputId).split('-')[0], 10);
      return Number.isFinite(pos) ? (pos - 1) : -1;
    }

    async function ensureProductJson() {
      if (productJson) return productJson;
      const url = (productUrl || window.location.pathname).replace(/\/$/, '') + '.js';
      try {
        const r = await fetch(url, { credentials: 'same-origin' });
        productJson = await r.json();
        return productJson;
      } catch {
        productJson = null;
        return null;
      }
    }

    // utils varianti
    function getVariantOptionsArr(v) {
      if (!v) return [];
      if (Array.isArray(v.options) && v.options.length) return v.options.slice();

      const out = [];
      if (v.option1 != null) out.push(String(v.option1));
      if (v.option2 != null) out.push(String(v.option2));
      if (v.option3 != null) out.push(String(v.option3));
      return out;
    }

    function vById(id) {
      return productJson?.variants?.find(v => Number(v.id) === Number(id)) || null;
    }

    function optionsMatchLike(vo, wanted) {
      if (!Array.isArray(vo) || !Array.isArray(wanted) || vo.length !== wanted.length) return false;

      for (let i = 0; i < wanted.length; i++) {
        const cand = norm(vo[i]);
        const w = norm(wanted[i]);

        if (i === persOptionIndex) {
          if (!(cand === w || cand.includes(w) || w.includes(cand))) return false;
        } else {
          if (cand !== w) return false;
        }
      }

      return true;
    }

    function vByOptions(optsArr) {
      if (!productJson) return null;
      return productJson.variants.find(v => optionsMatchLike(getVariantOptionsArr(v), optsArr)) || null;
    }

    function findVariantWithPersValueLikeCurrent(curV, targetVal) {
      if (!curV || persOptionIndex < 0 || !productJson) return null;
      const curOpts = getVariantOptionsArr(curV);
      if (!curOpts.length) return null;

      const exactOpts = curOpts.slice();
      exactOpts[persOptionIndex] = targetVal;
      const vExact = vByOptions(exactOpts);
      if (vExact) return vExact;

      const othersEqual = (v) => {
        const vo = getVariantOptionsArr(v);
        if (vo.length !== curOpts.length) return false;

        for (let i = 0; i < vo.length; i++) {
          if (i === persOptionIndex) continue;
          if (norm(vo[i]) !== norm(curOpts[i])) return false;
        }

        return true;
      };

      const want = norm(targetVal);
      const persFuzzy = (v) => {
        const vo = getVariantOptionsArr(v);
        const cand = norm(vo[persOptionIndex] ?? '');
        return cand === want || cand.includes(want) || want.includes(cand);
      };

      const vSameOthers = productJson.variants.find(v => othersEqual(v) && persFuzzy(v));
      if (vSameOthers) return vSameOthers;

      return productJson.variants.find(persFuzzy) || null;
    }

    function priceForPersValueLikeCurrent(curV, targetVal) {
      const v = findVariantWithPersValueLikeCurrent(curV, targetVal);
      if (!v || v.price == null) return null;
      const cents = Math.round(Number(v.price));
      return Number.isFinite(cents) ? cents : null;
    }

    function computeFees(curV) {
      if (!curV) {
        return {
          pNo: null, pBottle: null, pStick: null, pBoth: null,
          feeBottle: 0, feeStick: 0, feeBoth: 0
        };
      }

      const pNo     = priceForPersValueLikeCurrent(curV, VAL.no);
      const pBottle = priceForPersValueLikeCurrent(curV, VAL.bottle);
      const pStick  = priceForPersValueLikeCurrent(curV, VAL.stick);
      const pBoth   = priceForPersValueLikeCurrent(curV, VAL.both);

      const feeBottle = (pBottle != null && pNo != null) ? Math.max(0, pBottle - pNo) : 0;
      const feeStick  = (pStick  != null && pNo != null) ? Math.max(0, pStick  - pNo) : 0;
      const feeBoth   = (pBoth   != null && pNo != null) ? Math.max(0, pBoth   - pNo) : Math.max(0, feeBottle + feeStick);

      return { pNo, pBottle, pStick, pBoth, feeBottle, feeStick, feeBoth };
    }

    // ----- trova il fieldset della personalizzazione + indice opzione
    function findPersControl() {
      const container = getVariantPickerContainer();
      if (!container) return null;

      const fieldsets = Array.from(container.querySelectorAll('fieldset'))
        .filter(fs => fs.querySelector('input[type="radio"]'));

      if (!fieldsets.length) return null;

      const want = {
        no: norm(VAL.no),
        bottle: norm(VAL.bottle),
        stick: norm(VAL.stick),
        both: norm(VAL.both)
      };

      function scoreFs(fs) {
        const radios = Array.from(fs.querySelectorAll('input[type="radio"]'));
        const labelsMap = new Map();

        radios.forEach(r => {
          const lab = r.closest('label') || fs.querySelector(`label[for="${r.id}"]`);
          const t = lab?.querySelector('.variant-option__checkbox-label__text')?.textContent || lab?.textContent || '';
          labelsMap.set(r, norm(t));
        });

        const has = (val) => radios.some(r =>
          norm(r.value) === val ||
          norm(r.dataset.optionValue || '') === val ||
          (labelsMap.get(r) || '').includes(val)
        );

        const hits = [want.no, want.bottle, want.stick, want.both].filter(v => has(v)).length;
        return { fs, radios, labelsMap, hits };
      }

      let best = null;
      for (const fs of fieldsets) {
        const s = scoreFs(fs);
        if (!best || s.hits > best.hits) best = s;
      }

      if (!best || best.hits < 2) return null;

      const idxDom = detectPersIndexFromDom(best.fs);
      if (idxDom >= 0) persOptionIndexFromDom = idxDom;

      return {
        set(valWanted) {
          const radios = Array.from(best.fs.querySelectorAll('input[type="radio"]'));
          const wanted = norm(valWanted);

          let input = radios.find(i =>
            norm(i.value) === wanted ||
            norm(i.dataset.optionValue || '') === wanted
          );

          if (!input) {
            input = radios.find(i => {
              const lab = i.closest('label') || best.fs.querySelector(`label[for="${i.id}"]`);
              const t = lab?.querySelector('.variant-option__checkbox-label__text')?.textContent || lab?.textContent || '';
              return norm(t).includes(wanted);
            });
          }

          if (!input || input.disabled) return false;

          const active   = document.activeElement;
          const selStart = active?.selectionStart ?? null;
          const selEnd   = active?.selectionEnd ?? null;

          const label = input.closest('label') || best.fs.querySelector(`label[for="${input.id}"]`);
          if (label && typeof label.click === 'function') {
            label.click();
          } else {
            input.checked = true;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (active && (active === bottleInput || active === stickInput)) {
            setTimeout(() => {
              active.focus();
              try {
                if (selStart != null && selEnd != null && typeof active.setSelectionRange === 'function') {
                  active.setSelectionRange(selStart, selEnd);
                }
              } catch {}
            }, 0);
          }

          return true;
        }
      };
    }

    // ====== PRICE CONTAINER OBSERVER (no loop) ======
    let priceMo;

    function observePriceContainer() {
      priceMo?.disconnect();
      const pc = getPriceContainer();
      if (!pc) return;

      priceMo = new MutationObserver(() => {
        refreshFooterAndNote();
      });

      priceMo.observe(pc, { childList: true, subtree: true });
    }

    // ----- UI helpers (properties)
    function ensurePropertyInput(name) {
      const form = root.closest('form');
      if (!form) return null;

      const sel = form.querySelector(`input[name="properties[${name}]"]`);
      if (sel) return sel;

      const inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = `properties[${name}]`;
      form.appendChild(inp);
      return inp;
    }

    function removePropertyInputByNames(names = []) {
      const form = root.closest('form');
      if (!form) return;

      names.forEach((n) => {
        const el = form.querySelector(`input[name="properties[${n}]"]`);
        if (el) el.remove();
      });
    }

    function setProperty(name, value) {
      const form = root.closest('form');
      if (!form || !name) return;

      removePropertyInputByNames(['Bottle engraving', 'Sticks engraving', name]);
      if (!value) return;

      const inp = ensurePropertyInput(name);
      if (inp) inp.value = value;
    }

    function updateSummary() {
      const b = bottleInput.value.trim();
      const s = stickInput.value.trim();

      if (bottleOut) bottleOut.textContent = b || '';
      if (stickOut)  stickOut.textContent  = s || '';

      if (bottleRow) bottleRow.classList.toggle('hidden', !b);
      if (stickRow)  stickRow.classList.toggle('hidden', !s);

      const hasAny = Boolean(b || s);
      summary.classList.toggle('hidden', !hasAny);
      openBtn.classList.toggle('hidden', hasAny);
    }

    function computeWantedValue() {
      const hasBottle = !!norm(bottleInput?.value);
      const hasStick  = !!norm(stickInput?.value);

      if (!hasBottle && !hasStick) return VAL.no;
      if (hasBottle && hasStick)   return VAL.both;
      if (hasBottle)               return VAL.bottle;
      return VAL.stick;
    }

    // debounced
    let setVariantTmr = null;

    function setPersVariantFromInputs() {
      clearTimeout(setVariantTmr);
      setVariantTmr = setTimeout(() => {
        const ctrl = findPersControl();
        if (!ctrl) return;

        ctrl.set(computeWantedValue());
        setTimeout(() => {
          wireVariantInputObserver();
          refreshFooterAndNote();
        }, 80);
      }, 120);
    }

    // Fees + UI prezzo
    async function refreshFooterAndNote() {
      await ensureProductJson();

      if (persOptionIndexFromDom >= 0) {
        persOptionIndex = persOptionIndexFromDom;
      } else if (persOptionIndex < 0 && Array.isArray(productJson?.options)) {
        const opts = productJson.options.map(norm);
        const candidates = ['personaliz', 'personalizzazione', 'custom', 'incisione'];
        let idx = -1;

        for (let i = 0; i < opts.length; i++) {
          const o = opts[i];
          if (candidates.some(c => o.includes(c))) {
            idx = i;
            break;
          }
        }

        persOptionIndex = idx >= 0 ? idx : 2;
      }

      const curId = getCurrentVariantId();
      const curV  = curId ? vById(curId) : null;
      if (!curV) return;

      const { feeBottle, feeStick } = computeFees(curV);

      const totalCents = Math.round(Number(curV.price) || 0);
      if (footerTotal) footerTotal.textContent = formatMoney(totalCents);

      let stepExtra = 0;
      if (currentStep === 1) {
        stepExtra = norm(bottleInput.value) ? feeBottle : 0;
      } else {
        stepExtra = norm(stickInput.value) ? feeStick : 0;
      }

      if (footerExtra) {
        if (stepExtra > 0) {
          footerExtra.textContent = `(+${formatMoney(stepExtra)})`;
          footerExtra.classList.remove('hidden');
        } else {
          footerExtra.textContent = '';
          footerExtra.classList.add('hidden');
        }
      }

      const totalExtra =
        (norm(bottleInput.value) ? feeBottle : 0) +
        (norm(stickInput.value) ? feeStick : 0);

      priceMo?.disconnect();
      const { note: persNote, amt: persNoteAmount } = getPersNoteEls();

      if (persNote && persNoteAmount) {
        if (totalExtra > 0) {
          persNoteAmount.textContent = formatMoney(totalExtra);
          persNote.classList.remove('hidden');
        } else {
          persNoteAmount.textContent = '';
          persNote.classList.add('hidden');
        }
      }

      observePriceContainer();
    }

    // ---- Helpers riepilogo
    function summaryRowLabel(rowSel) {
      const row = document.querySelector(rowSel);
      if (!row) return '';
      const firstNodeText = row.childNodes[0]?.textContent ?? '';
      return String(firstNodeText).replace(':', '').trim();
    }

    function summaryValue(sel) {
      const el = document.querySelector(sel);
      return (el?.textContent || '').trim();
    }

    function applyCurrentValues() {
      updateSummary();

      const bottleLabel = summaryRowLabel('#summary-bottle-row');
      const stickLabel  = summaryRowLabel('#summary-stick-row');

      const bottleVal = summaryValue('#summary-bottle');
      const stickVal  = summaryValue('#summary-stick');

      removePropertyInputByNames([
        'Bottle engraving',
        'Sticks engraving',
        'Testo bottiglia',
        'Testo flacone',
        'Testo bastoncino'
      ]);

      if (bottleLabel && bottleVal) setProperty(bottleLabel, bottleVal);
      if (stickLabel  && stickVal)  setProperty(stickLabel,  stickVal);

      setPersVariantFromInputs();
    }

    // ----- STEP & UI
    const btnNexts    = modal.querySelectorAll('.pers-next');
    const btnConfirms = modal.querySelectorAll('.pers-confirm');

    function showAll(list) { list.forEach(el => el.classList.remove('hidden')); }
    function hideAll(list) { list.forEach(el => el.classList.add('hidden')); }

    function gotoStep(step) {
      currentStep = step;
      const stage = modal.querySelector('.PersStage');

      if (step === 1) {
        stage?.classList.replace('is-step-2', 'is-step-1');
        step1.classList.add('is-active');
        step2.classList.remove('is-active');
        tabs[0]?.classList.add('is-active');
        tabs[1]?.classList.remove('is-active');

        if (previewBottleSrc) previewImg.src = previewBottleSrc;
        previewText.innerHTML = buildPreviewHTML('bottle', bottleInput.value);

        showAll(btnNexts);
        hideAll(btnConfirms);

        requestAnimationFrame(fitPreviewText);
      } else {
        stage?.classList.replace('is-step-1', 'is-step-2');
        step1.classList.remove('is-active');
        step2.classList.add('is-active');
        tabs[0]?.classList.remove('is-active');
        tabs[1]?.classList.add('is-active');

        if (previewStickSrc) previewImg.src = previewStickSrc;
        previewText.innerHTML = buildPreviewHTML('stick', stickInput.value);

        requestAnimationFrame(fitPreviewText);

        hideAll(btnNexts);
        showAll(btnConfirms);
      }

      refreshFooterAndNote();

      // ricalcola focusables e porta il focus al campo corretto dello step
      setTimeout(() => {
        collectFocusable(modal);
        const targetInput = step === 1 ? bottleInput : stickInput;
        mountSharedPickerForInput(targetInput);
        targetInput?.focus();
      }, 0);
    }

    // === Focus Trap ===
    let focusableEls = [];
    let firstFocusableEl = null;
    let lastFocusableEl = null;
    let prevActiveElement = null;

    function isVisible(el) {
      if (!el) return false;
      if (el.closest('.hidden')) return false;

      const style = window.getComputedStyle(el);
      if (style.visibility === 'hidden' || style.display === 'none') return false;

      const rect = el.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return false;

      return true;
    }

    function collectFocusable(modalRoot) {
      focusableEls = Array.from(
        modalRoot.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(isVisible);

      firstFocusableEl = focusableEls[0] || null;
      lastFocusableEl  = focusableEls[focusableEls.length - 1] || null;
    }

    function handleTrapTab(e) {
      if (e.key !== 'Tab') return;

      if (!isVisible(document.activeElement)) {
        e.preventDefault();
        collectFocusable(modal);
        (firstFocusableEl || modal.querySelector('.PersClose') || modal).focus();
        return;
      }

      if (!focusableEls.length) return;

      if (!modal.contains(document.activeElement)) {
        e.preventDefault();
        (firstFocusableEl || modal.querySelector('.PersClose') || modal).focus();
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl?.focus();
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl?.focus();
        }
      }
    }

    function trapFocus(modalRoot) {
      collectFocusable(modalRoot);
      modalRoot.addEventListener('keydown', handleTrapTab);
    }

    function releaseFocus(modalRoot) {
      modalRoot.removeEventListener('keydown', handleTrapTab);
    }

    // ----- EVENTI
    const openModal = async () => {
      await ensureProductJson();
      prevActiveElement = document.activeElement;

      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');

      const head = document.querySelector('header');
      if (head?.style) head.style.zIndex = '0';

      gotoStep(1);
      mountSharedPickerForInput(bottleInput);
      setPersVariantFromInputs();

      setTimeout(() => {
        trapFocus(modal);
        collectFocusable(modal);
        (modal.querySelector('.PersClose') || firstFocusableEl || modal).focus();
      }, 10);
    };

    function closeModal() {
      applyCurrentValues();

      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');

      const head = document.querySelector('header');
      if (head?.style) head.style.zIndex = '';

      releaseFocus(modal);

      if (prevActiveElement && typeof prevActiveElement.focus === 'function') {
        prevActiveElement.focus();
      } else {
        openBtn?.focus();
      }
    }

    openBtn.addEventListener('click', openModal);
    editBtn?.addEventListener('click', openModal);
    backdrop.addEventListener('click', closeModal);
    closeBtns.forEach(b => b.addEventListener('click', closeModal));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    tabs.forEach(t =>
      t.addEventListener('click', () => gotoStep(Number(t.dataset.stepTarget || '1')))
    );

    btnNexts.forEach(btn =>
      btn.addEventListener('click', () => gotoStep(2))
    );

    btnConfirms.forEach(btn =>
      btn.addEventListener('click', () => {
        applyCurrentValues();
        closeModal();
      })
    );

    // =========================================================
    //  ICON PICKER CONDIVISO
    //  - un solo selettore per entrambi gli input
    //  - viene montato DOPO l'input, nel placeholder data-position="back"
    //  - icona iniziale: faccina
    //  - il conteggio tratta ogni icona della lista come 1 carattere
    //  - gestisce digitazione, incolla e inserimento icone
    // =========================================================

    const ICON_LIST = [
      { icon: '\u263A',       label: 'Smile',      weight: 1 },
      { icon: '\u2605',       label: 'Stella',     weight: 1 },
      { icon: '\u273F',       label: 'Fiore',      weight: 1 },
      { icon: '\u2665',       label: 'Cuore',      weight: 1 },
      { icon: '\u266B',       label: 'Nota',       weight: 1 },
      { icon: '\u2600',       label: 'Sole',       weight: 1 },
      { icon: '\u2601',       label: 'Nuvola',     weight: 1 },
      { icon: '\u262E',       label: 'Pace',       weight: 1 },
      { icon: '\u221E',       label: 'Infinito',   weight: 1 },

      { icon: '\u2648\uFE0E', label: 'Ariete',     weight: 2 },
      { icon: '\u2649\uFE0E', label: 'Toro',       weight: 2 },
      { icon: '\u264A\uFE0E', label: 'Gemelli',    weight: 2 },
      { icon: '\u264B\uFE0E', label: 'Cancro',     weight: 2 },
      { icon: '\u264C\uFE0E', label: 'Leone',      weight: 2 },
      { icon: '\u264D\uFE0E', label: 'Vergine',    weight: 2 },
      { icon: '\u264E\uFE0E', label: 'Bilancia',   weight: 2 },
      { icon: '\u264F\uFE0E', label: 'Scorpione',  weight: 2 },
      { icon: '\u2650\uFE0E', label: 'Sagittario', weight: 2 },
      { icon: '\u2651\uFE0E', label: 'Capricorno', weight: 2 },
      { icon: '\u2652\uFE0E', label: 'Acquario',   weight: 2 },
      { icon: '\u2653\uFE0E', label: 'Pesci',      weight: 2 }
    ];

    let activeIconInput = null;

    // ---------------------------------------------------------
    //  TOKENIZZAZIONE CUSTOM
    //  - ogni icona presente in ICON_LIST vale 1 token
    //  - il testo normale viene contato per grapheme
    //  - variation selector FE0E/FE0F non crea token extra
    // ---------------------------------------------------------

    const ICON_VALUES = ICON_LIST.map(x => x.icon).sort((a, b) => b.length - a.length);

    const ICON_WEIGHT_MAP = new Map(
      ICON_LIST.map(x => [x.icon, Number(x.weight || 1)])
    );

    function getTokenWeight(token) {
      return ICON_WEIGHT_MAP.get(token) || 1;
    }

    function getTextGraphemes(str) {
      const text = String(str || '');
      try {
        if (typeof Intl !== 'undefined' && Intl.Segmenter) {
          const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
          return Array.from(seg.segment(text), x => x.segment);
        }
      } catch {}
      return Array.from(text);
    }

    function tokenizeValue(str) {
      const text = String(str || '');
      const tokens = [];
      let i = 0;

      while (i < text.length) {
        let matchedIcon = null;

        for (const icon of ICON_VALUES) {
          if (text.slice(i, i + icon.length) === icon) {
            matchedIcon = icon;
            break;
          }
        }

        if (matchedIcon) {
          tokens.push(matchedIcon);
          i += matchedIcon.length;
          continue;
        }

        const rest = text.slice(i);
        const graphemes = getTextGraphemes(rest);
        const first = graphemes[0] || rest.charAt(0);

        tokens.push(first);
        i += first.length;
      }

      return tokens;
    }

    function getCharCount(str) {
      return tokenizeValue(str).reduce((sum, token) => {
        return sum + getTokenWeight(token);
      }, 0);
    }

    function getInputMaxChars(inputEl) {
      return Number(inputEl?.getAttribute('maxlength') || 0);
    }

    function codeUnitIndexToTokenIndex(str, codeUnitIndex) {
      const text = String(str || '');
      const safeIndex = Math.max(0, Math.min(codeUnitIndex ?? text.length, text.length));

      let consumed = 0;
      let tokenIndex = 0;
      const tokens = tokenizeValue(text);

      for (const token of tokens) {
        if (consumed >= safeIndex) break;
        consumed += token.length;
        tokenIndex++;
      }

      return tokenIndex;
    }

    function tokenIndexToCodeUnitIndex(str, tokenIndex) {
      const tokens = tokenizeValue(str);
      const safeIndex = Math.max(0, Math.min(tokenIndex ?? tokens.length, tokens.length));
      return tokens.slice(0, safeIndex).join('').length;
    }

    function trimToMaxChars(value, maxChars) {
      if (!maxChars || maxChars <= 0) return String(value || '');

      const tokens = tokenizeValue(value);
      const out = [];
      let used = 0;

      for (const token of tokens) {
        const weight = getTokenWeight(token);
        if (used + weight > maxChars) break;
        out.push(token);
        used += weight;
      }

      return out.join('');
    }

    function enforceMaxChars(inputEl) {
      if (!inputEl) return;

      const max = getInputMaxChars(inputEl);
      if (!max) return;

      const oldValue = String(inputEl.value || '');
      const oldStartCU = inputEl.selectionStart ?? oldValue.length;

      const oldStartToken = codeUnitIndexToTokenIndex(oldValue, oldStartCU);
      const trimmed = trimToMaxChars(oldValue, max);

      if (trimmed !== oldValue) {
        inputEl.value = trimmed;

        const nextPosCU = tokenIndexToCodeUnitIndex(
          trimmed,
          Math.min(oldStartToken, getCharCount(trimmed))
        );

        try {
          inputEl.setSelectionRange(nextPosCU, nextPosCU);
        } catch {}
      }
    }

    function insertTextAtCursorWithLimit(inputEl, textToInsert) {
      if (!inputEl) return false;

      const currentValue = String(inputEl.value || '');
      const maxChars = getInputMaxChars(inputEl);

      const startCU = inputEl.selectionStart ?? currentValue.length;
      const endCU   = inputEl.selectionEnd   ?? currentValue.length;

      const startToken = codeUnitIndexToTokenIndex(currentValue, startCU);
      const endToken   = codeUnitIndexToTokenIndex(currentValue, endCU);

      const currentTokens = tokenizeValue(currentValue);
      const insertTokens  = tokenizeValue(textToInsert);

      const before = currentTokens.slice(0, startToken);
      const after  = currentTokens.slice(endToken);

      let allowedInsertTokens = insertTokens;

      if (maxChars > 0) {
        const usedBefore = before.reduce((sum, token) => sum + getTokenWeight(token), 0);
        const usedAfter  = after.reduce((sum, token) => sum + getTokenWeight(token), 0);
        let available = Math.max(0, maxChars - usedBefore - usedAfter);

        allowedInsertTokens = [];
        for (const token of insertTokens) {
          const weight = getTokenWeight(token);
          if (weight > available) break;
          allowedInsertTokens.push(token);
          available -= weight;
        }
      }

      const nextTokens = [...before, ...allowedInsertTokens, ...after];
      const nextValue = nextTokens.join('');

      inputEl.value = nextValue;

      const caretToken = before.length + allowedInsertTokens.length;
      const caretCU = tokenIndexToCodeUnitIndex(nextValue, caretToken);

      inputEl.focus();
      try {
        inputEl.setSelectionRange(caretCU, caretCU);
      } catch {}

      return allowedInsertTokens.length > 0;
    }

    function createSharedIconPicker() {
      const picker = document.createElement('div');
      picker.className = 'IconPicker IconPicker--shared';

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'IconPicker__toggle';
      toggle.setAttribute('aria-label', 'Inserisci icona');
      toggle.textContent = '\u263A'; // faccina iniziale

      const dropdown = document.createElement('div');
      dropdown.className = 'IconPicker__dropdown hidden';

      ICON_LIST.forEach(entry => {
        const opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'IconPicker__option';
        opt.dataset.icon = entry.icon;
        opt.title = entry.label;
        opt.textContent = entry.icon;
        dropdown.appendChild(opt);
      });

      picker.appendChild(toggle);
      picker.appendChild(dropdown);
      return picker;
    }

    const sharedIconPicker = createSharedIconPicker();
    const sharedIconToggle = sharedIconPicker.querySelector('.IconPicker__toggle');
    const sharedIconDropdown = sharedIconPicker.querySelector('.IconPicker__dropdown');

    // monta il picker nel placeholder "back" della riga corretta, quindi DOPO l'input
    function mountSharedPickerForInput(inputEl) {
      if (!inputEl) return;

      activeIconInput = inputEl;

      const row = inputEl.closest('.IconPickerRow');
      if (!row) return;

      row.querySelectorAll('.IconPicker[data-position="front"]').forEach(el => {
        el.classList.add('hidden');
        el.setAttribute('aria-hidden', 'true');
      });

      const backSlot = row.querySelector('.IconPicker[data-position="back"]');
      if (!backSlot) return;

      backSlot.classList.remove('hidden');
      backSlot.setAttribute('aria-hidden', 'false');

      if (sharedIconPicker.parentNode !== backSlot) {
        backSlot.innerHTML = '';
        backSlot.appendChild(sharedIconPicker);
      }
    }

    // build preview as plain escaped HTML
    function buildPreviewHTML(target, text) {
      return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    // plain text version for summary/properties
    function buildPreviewString(target, text) {
      return String(text || '');
    }

    // auto-fit preview text
    const measureSpan = document.createElement('span');
    measureSpan.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;font-weight:700;letter-spacing:.08em;';
    measureSpan.style.fontFamily = "'Segoe UI Symbol', sans-serif";
    document.body.appendChild(measureSpan);

    function fitPreviewText() {
      if (!previewText) return;
      const stage = previewText.closest('.PersStage');
      if (!stage) return;

      previewText.style.fontSize = '';
      let size = parseFloat(getComputedStyle(previewText).fontSize);
      const minSize = 6;

      const isStep1 = stage.classList.contains('is-step-1');
      const maxLen = isStep1 ? stage.offsetHeight * 0.35 : stage.offsetWidth * 0.35;

      measureSpan.textContent = previewText.textContent;
      measureSpan.style.fontSize = size + 'px';

      while (measureSpan.offsetWidth > maxLen && size > minSize) {
        size -= 0.5;
        measureSpan.style.fontSize = size + 'px';
      }

      previewText.style.fontSize = size + 'px';
    }

    // update preview text and auto-fit
    function updatePreview() {
      if (currentStep === 1) {
        previewText.innerHTML = buildPreviewHTML('bottle', bottleInput.value);
      } else {
        previewText.innerHTML = buildPreviewHTML('stick', stickInput.value);
      }
      fitPreviewText();
    }

    sharedIconToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      sharedIconDropdown.classList.toggle('hidden');
    });

    sharedIconDropdown.querySelectorAll('.IconPicker__option').forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();

        if (!activeIconInput) return;

        const icon = opt.dataset.icon || '';
        insertTextAtCursorWithLimit(activeIconInput, icon);

        sharedIconDropdown.classList.add('hidden');

        if (activeIconInput === bottleInput) {
          onBottleInput();
        } else if (activeIconInput === stickInput) {
          onStickInput();
        }
      });
    });

    document.addEventListener('click', () => {
      sharedIconDropdown.classList.add('hidden');
    });

    function bindSharedPickerToInput(inputEl) {
      if (!inputEl) return;

      const activate = () => mountSharedPickerForInput(inputEl);
      inputEl.addEventListener('focus', activate);
      inputEl.addEventListener('click', activate);
    }

    bindSharedPickerToInput(bottleInput);
    bindSharedPickerToInput(stickInput);

    // al primo load nascondiamo tutti i placeholder front
    modal.querySelectorAll('.IconPicker[data-position="front"]').forEach(el => {
      el.classList.add('hidden');
      el.setAttribute('aria-hidden', 'true');
    });

    // Input handlers
    function formatCount(input) {
      const max = input.getAttribute('maxlength') || '18';
      return getCharCount(input.value) + '/' + max;
    }

    function onBottleInput() {
      enforceMaxChars(bottleInput);

      if (step1.classList.contains('is-active')) updatePreview();
      if (bottleCount)       bottleCount.textContent = formatCount(bottleInput);
      if (bottleCountInline) bottleCountInline.textContent = formatCount(bottleInput);

      setPersVariantFromInputs();
    }

    function onStickInput() {
      stickInput.value = stickInput.value.toUpperCase();
      enforceMaxChars(stickInput);

      if (step2.classList.contains('is-active')) updatePreview();
      if (stickCount)       stickCount.textContent = formatCount(stickInput);
      if (stickCountInline) stickCountInline.textContent = formatCount(stickInput);

      setPersVariantFromInputs();
    }

    bottleInput.addEventListener('input', onBottleInput);
    stickInput.addEventListener('input', onStickInput);

    function bindBeforeInputLimit(inputEl, handler) {
      if (!inputEl) return;

      inputEl.addEventListener('beforeinput', () => {
        requestAnimationFrame(handler);
      });

      inputEl.addEventListener('paste', () => {
        requestAnimationFrame(handler);
      });
    }

    bindBeforeInputLimit(bottleInput, onBottleInput);
    bindBeforeInputLimit(stickInput, onStickInput);

    bindMaxLenMessageFor(bottleInput);
    bindMaxLenMessageFor(stickInput);

    // Submit → properties
    const productForm = root.closest('form');
    if (productForm) {
      productForm.addEventListener('submit', () => applyCurrentValues());
    }

    // osserva input[ref="variantId"]
    function wireVariantInputObserver() {
      const vInput = getVariantInput();
      if (!vInput || vInput._persObserved) return;

      new MutationObserver(() => setTimeout(refreshFooterAndNote, 0))
        .observe(vInput, { attributes: true, attributeFilter: ['value'] });

      vInput._persObserved = true;
    }

    const onVariantEvent = () => {
      wireVariantInputObserver();
      setTimeout(refreshFooterAndNote, 0);
    };

    document.addEventListener('variant:update', onVariantEvent, { passive: true });
    document.addEventListener('variant:change', onVariantEvent, { passive: true });

    // ----- init
    updateSummary();
    wireVariantInputObserver();
    observePriceContainer();

    requestAnimationFrame(() => {
      mountSharedPickerForInput(bottleInput);
      onBottleInput();
      onStickInput();
      setPersVariantFromInputs();
      refreshFooterAndNote();
    });
  })(); */

  /* Personalizzazione prodotto — prodotto separato */
  (function () {
    const openBtn  = document.getElementById('open-personalizer');
    const editBtn  = document.getElementById('edit-personalizer');
    const summary  = document.getElementById('pers-summary');
    const modal    = document.getElementById('personalizer');
    if (!modal || !openBtn || !summary) return;

    const root       = openBtn.closest('.product-form-buttons');
    const pfc        = root.closest('product-form-component');
    const productUrl = pfc?.dataset?.productUrl || window.location.pathname;
    const productId  = pfc?.dataset?.productId || pfc?.getAttribute('data-product-id') || null;
    const productForm = root.closest('form');

    const VAL = {
      no:     root.dataset.persValueNo     || 'No',
      bottle: root.dataset.persValueBottle || 'Bottle',
      stick:  root.dataset.persValueStick  || 'Sticks',
      both:   root.dataset.persValueBoth   || 'Both',
    };

    const persProductHandle = root.dataset.persProductHandle || '';

    // ----- Elements modale
    const backdrop   = modal.querySelector('.PersonalizerModal__backdrop');
    const closeBtns  = modal.querySelectorAll('[data-close]');
    const step1      = modal.querySelector('.Step[data-step-index="1"]');
    const step2      = modal.querySelector('.Step[data-step-index="2"]');
    const tabs       = modal.querySelectorAll('.PersTab');

    const previewImg  = modal.querySelector('#preview-image');
    const previewText = modal.querySelector('#preview-text');

    const bottleInput       = modal.querySelector('#bottle-text');
    const bottleCount       = modal.querySelector('#bottle-count');
    const bottleCountInline = modal.querySelector('#bottle-count-inline');

    const stickInput        = modal.querySelector('#stick-text');
    const stickCount        = modal.querySelector('#stick-count');
    const stickCountInline  = modal.querySelector('#stick-count-inline');

    // Summary in PDP
    const bottleRow = document.getElementById('summary-bottle-row');
    const stickRow  = document.getElementById('summary-stick-row');
    const bottleOut = document.getElementById('summary-bottle');
    const stickOut  = document.getElementById('summary-stick');

    // Footer modale
    const footerExtra = modal.querySelector('#pers-extra');
    const footerTotal = modal.querySelector('#pers-total');

    // Anteprime
    const previewBottleSrc = modal.dataset.previewBottleSrc || '';
    const previewStickSrc  = modal.dataset.previewStickSrc  || '';

    // Stato
    let currentStep = 1;
    const norm = (s) => String(s || '').trim().toLowerCase();

    // ===== Helpers PDP (prezzo + nota) =====
    function getPriceContainer() {
      const c1 = document.querySelector('[ref="priceContainer"]');
      if (c1) return c1;
      return document.querySelector('.product-price, .price, [data-price-container]') || null;
    }

    function getPersNoteEls() {
      const container = getPriceContainer() || document;
      const note = container.querySelector('#pers-note') || document.getElementById('pers-note');
      const amt  = container.querySelector('#pers-note-amount') || document.getElementById('pers-note-amount');
      return { note, amt };
    }

    function getDisplayedPriceEl() {
      const container = getPriceContainer() || document;
      return container.querySelector('.price') || document.querySelector('.price');
    }

    function parseMoneyToCents(text) {
      if (!text) return null;
      const normalized = String(text)
        .replace(/\s/g, '')
        .replace(/[^\d,.-]/g, '')
        .replace(/\.(?=\d{3}(?:\D|$))/g, '')
        .replace(',', '.');

      const value = Number(normalized);
      if (!Number.isFinite(value)) return null;
      return Math.round(value * 100);
    }

    function bindMaxLenMessageFor(inputEl) {
      if (!inputEl) return;
      const field = inputEl.closest('.Field');
      const msgEl = field ? field.querySelector('.MaxCharsMsg') : null;
      if (!msgEl) return;

      const update = () => {
        const count = getCharCount(inputEl.value);
        const max = Number(inputEl.getAttribute('maxlength') || 0);
        const show = max > 0 && count >= max;
        msgEl.hidden = !show;
      };

      inputEl.addEventListener('input', update);
      update();
    }

    // ----- Money
    function formatMoney(cents) {
      const moneyFormat = root?.dataset.moneyFormat || '';
      try {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney && moneyFormat) {
          return Shopify.formatMoney(Math.round(cents), moneyFormat);
        }
      } catch {}
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root?.dataset.currency || 'EUR'
      }).format(Math.round(cents) / 100);
    }

    // ----- Variant id corrente prodotto principale
    function getVariantInput() {
      return pfc?.querySelector('input[ref="variantId"]') || null;
    }

    function getCurrentVariantId() {
      const v = Number(getVariantInput()?.value);
      return Number.isFinite(v) && v > 0 ? v : null;
    }

    // ===== PRODUCT JSON =====
    let productJson = null;
    let persProductJson = null;
    let baseDisplayedPriceCents = null;

    async function ensureProductJson() {
      if (productJson) return productJson;
      const url = (productUrl || window.location.pathname).replace(/\/$/, '') + '.js';
      try {
        const r = await fetch(url, { credentials: 'same-origin' });
        productJson = await r.json();
        return productJson;
      } catch {
        productJson = null;
        return null;
      }
    }

    async function ensurePersProductJson() {
      if (persProductJson) return persProductJson;
      if (!persProductHandle) return null;

      try {
        const r = await fetch(`/products/${persProductHandle}.js`, { credentials: 'same-origin' });
        persProductJson = await r.json();
        return persProductJson;
      } catch {
        persProductJson = null;
        return null;
      }
    }

    function getVariantOptionsArr(v) {
      if (!v) return [];
      if (Array.isArray(v.options) && v.options.length) return v.options.slice();

      const out = [];
      if (v.option1 != null) out.push(String(v.option1));
      if (v.option2 != null) out.push(String(v.option2));
      if (v.option3 != null) out.push(String(v.option3));
      return out;
    }

    function mainVariantById(id) {
      return productJson?.variants?.find(v => Number(v.id) === Number(id)) || null;
    }

    function findPersVariantByValue(value) {
      if (!persProductJson?.variants?.length) return null;

      const wanted = norm(value);

      return persProductJson.variants.find(v => {
        const values = [
          v.title,
          ...getVariantOptionsArr(v)
        ].map(norm);

        return values.some(candidate =>
          candidate === wanted ||
          candidate.includes(wanted) ||
          wanted.includes(candidate)
        );
      }) || null;
    }

    function computeWantedValue() {
      const hasBottle = !!norm(bottleInput?.value);
      const hasStick  = !!norm(stickInput?.value);

      if (!hasBottle && !hasStick) return VAL.no;
      if (hasBottle && hasStick)   return VAL.both;
      if (hasBottle)               return VAL.bottle;
      return VAL.stick;
    }

    function computeFees() {
      const vNo     = findPersVariantByValue(VAL.no);
      const vBottle = findPersVariantByValue(VAL.bottle);
      const vStick  = findPersVariantByValue(VAL.stick);
      const vBoth   = findPersVariantByValue(VAL.both);

      const pNo     = vNo     ? Math.round(Number(vNo.price) || 0) : 0;
      const pBottle = vBottle ? Math.round(Number(vBottle.price) || 0) : 0;
      const pStick  = vStick  ? Math.round(Number(vStick.price) || 0) : 0;
      const pBoth   = vBoth   ? Math.round(Number(vBoth.price) || 0) : 0;

      return {
        pNo,
        pBottle,
        pStick,
        pBoth,
        feeBottle: Math.max(0, pBottle - pNo),
        feeStick:  Math.max(0, pStick - pNo),
        feeBoth:   Math.max(0, pBoth - pNo)
      };
    }

    // ====== PRICE CONTAINER OBSERVER ======
    let priceMo;

    function observePriceContainer() {
      priceMo?.disconnect();
      const pc = getPriceContainer();
      if (!pc) return;

      priceMo = new MutationObserver(() => {
        refreshFooterAndNote();
      });

      priceMo.observe(pc, { childList: true, subtree: true });
    }

    // ----- UI helpers (properties)
    function ensurePropertyInput(name) {
      const form = root.closest('form');
      if (!form) return null;

      const sel = form.querySelector(`input[name="properties[${CSS.escape(name)}]"]`);
      if (sel) return sel;

      const inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = `properties[${name}]`;
      form.appendChild(inp);
      return inp;
    }

    function removePropertyInputByNames(names = []) {
      const form = root.closest('form');
      if (!form) return;

      names.forEach((n) => {
        const escaped = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(n) : n;
        const el = form.querySelector(`input[name="properties[${escaped}]"]`);
        if (el) el.remove();
      });
    }

    function setProperty(name, value) {
      const form = root.closest('form');
      if (!form || !name) return;

      removePropertyInputByNames([name]);
      if (!value) return;

      const inp = ensurePropertyInput(name);
      if (inp) inp.value = value;
    }

    function updateSummary() {
      const b = bottleInput.value.trim();
      const s = stickInput.value.trim();

      if (bottleOut) bottleOut.textContent = b || '';
      if (stickOut)  stickOut.textContent  = s || '';

      if (bottleRow) bottleRow.classList.toggle('hidden', !b);
      if (stickRow)  stickRow.classList.toggle('hidden', !s);

      const hasAny = Boolean(b || s);
      summary.classList.toggle('hidden', !hasAny);
      openBtn.classList.toggle('hidden', hasAny);
    }

    async function refreshFooterAndNote() {
      await ensureProductJson();
      await ensurePersProductJson();

      const curId = getCurrentVariantId();
      const curV  = curId ? mainVariantById(curId) : null;
      if (!curV) return;

      const { feeBottle, feeStick, feeBoth } = computeFees();

      const wantedValue = computeWantedValue();
      const selectedPersVariant = findPersVariantByValue(wantedValue);
      const selectedPersPrice   = selectedPersVariant ? Math.round(Number(selectedPersVariant.price) || 0) : 0;
      const mainPrice           = Math.round(Number(curV.price) || 0);
      const totalCents          = mainPrice + selectedPersPrice;

      if (footerTotal) {
        footerTotal.textContent = formatMoney(totalCents);
      }

      let stepExtra = 0;

      if (currentStep === 1) {
        stepExtra = norm(bottleInput.value) ? feeBottle : 0;
      } else {
        const hasBottle = !!norm(bottleInput.value);
        const hasStick  = !!norm(stickInput.value);

        if (hasBottle && hasStick) {
          stepExtra = Math.max(0, feeBoth - feeBottle);
        } else if (!hasBottle && hasStick) {
          stepExtra = feeStick;
        } else {
          stepExtra = 0;
        }
      }

      if (footerExtra) {
        if (stepExtra > 0) {
          footerExtra.textContent = `(+${formatMoney(stepExtra)})`;
          footerExtra.classList.remove('hidden');
        } else {
          footerExtra.textContent = '';
          footerExtra.classList.add('hidden');
        }
      }

      priceMo?.disconnect();

      const { note: persNote, amt: persNoteAmount } = getPersNoteEls();

      if (persNote && persNoteAmount) {
        if (selectedPersPrice > 0) {
          persNoteAmount.textContent = formatMoney(selectedPersPrice);
          persNote.classList.remove('hidden');
        } else {
          persNoteAmount.textContent = '';
          persNote.classList.add('hidden');
        }
      }

      const displayedPriceEl = getDisplayedPriceEl();
      if (displayedPriceEl) {
        displayedPriceEl.textContent = formatMoney(totalCents);
      }

      observePriceContainer();
    }

    // ---- Helpers riepilogo
    function summaryRowLabel(rowSel) {
      const row = document.querySelector(rowSel);
      if (!row) return '';
      const firstNodeText = row.childNodes[0]?.textContent ?? '';
      return String(firstNodeText).replace(':', '').trim();
    }

    function summaryValue(sel) {
      const el = document.querySelector(sel);
      return (el?.textContent || '').trim();
    }

    function applyCurrentValues() {
      updateSummary();

      const bottleLabel = summaryRowLabel('#summary-bottle-row');
      const stickLabel  = summaryRowLabel('#summary-stick-row');

      const bottleVal = summaryValue('#summary-bottle');
      const stickVal  = summaryValue('#summary-stick');

      removePropertyInputByNames([
        'Bottle engraving',
        'Sticks engraving',
        'Testo bottiglia',
        'Testo flacone',
        'Testo bastoncino'
      ]);

      if (bottleLabel && bottleVal) setProperty(bottleLabel, bottleVal);
      if (stickLabel  && stickVal)  setProperty(stickLabel,  stickVal);
    }
    function syncPersonalizerStateFromInputs() {
      const bottleVal = String(bottleInput?.value || '').trim();
      const stickVal  = String(stickInput?.value || '').trim();
      const hasAny = Boolean(bottleVal || stickVal);

      updateSummary();
      applyCurrentValues();
      syncAcceleratedCheckoutAdditionalItem();
      refreshFooterAndNote();

      if (summary) {
        summary.classList.toggle('hidden', !hasAny);
      }

      if (openBtn) {
        openBtn.classList.toggle('hidden', hasAny);
      }

      if (editBtn) {
        editBtn.classList.toggle('hidden', !hasAny);
      }

      if (bottleOut) bottleOut.textContent = bottleVal;
      if (stickOut)  stickOut.textContent  = stickVal;

      if (bottleRow) bottleRow.classList.toggle('hidden', !bottleVal);
      if (stickRow)  stickRow.classList.toggle('hidden', !stickVal);
    }

    // ----- STEP & UI
    const btnNexts    = modal.querySelectorAll('.pers-next');
    const btnConfirms = modal.querySelectorAll('.pers-confirm');

    function showAll(list) { list.forEach(el => el.classList.remove('hidden')); }
    function hideAll(list) { list.forEach(el => el.classList.add('hidden')); }

    function gotoStep(step) {
      currentStep = step;
      const stage = modal.querySelector('.PersStage');

      if (step === 1) {
        stage?.classList.replace('is-step-2', 'is-step-1');
        step1.classList.add('is-active');
        step2.classList.remove('is-active');
        tabs[0]?.classList.add('is-active');
        tabs[1]?.classList.remove('is-active');

        if (previewBottleSrc) previewImg.src = previewBottleSrc;
        previewText.innerHTML = buildPreviewHTML('bottle', bottleInput.value);

        showAll(btnNexts);
        hideAll(btnConfirms);

        requestAnimationFrame(fitPreviewText);
      } else {
        stage?.classList.replace('is-step-1', 'is-step-2');
        step1.classList.remove('is-active');
        step2.classList.add('is-active');
        tabs[0]?.classList.remove('is-active');
        tabs[1]?.classList.add('is-active');

        if (previewStickSrc) previewImg.src = previewStickSrc;
        previewText.innerHTML = buildPreviewHTML('stick', stickInput.value);

        requestAnimationFrame(fitPreviewText);

        hideAll(btnNexts);
        showAll(btnConfirms);
      }

      refreshFooterAndNote();

      setTimeout(() => {
        collectFocusable(modal);
        const targetInput = step === 1 ? bottleInput : stickInput;
        mountSharedPickerForInput(targetInput);
        targetInput?.focus();
      }, 0);
    }

    // === Focus Trap ===
    let focusableEls = [];
    let firstFocusableEl = null;
    let lastFocusableEl = null;
    let prevActiveElement = null;

    function isVisible(el) {
      if (!el) return false;
      if (el.closest('.hidden')) return false;

      const style = window.getComputedStyle(el);
      if (style.visibility === 'hidden' || style.display === 'none') return false;

      const rect = el.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return false;

      return true;
    }

    function collectFocusable(modalRoot) {
      focusableEls = Array.from(
        modalRoot.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(isVisible);

      firstFocusableEl = focusableEls[0] || null;
      lastFocusableEl  = focusableEls[focusableEls.length - 1] || null;
    }

    function handleTrapTab(e) {
      if (e.key !== 'Tab') return;

      if (!isVisible(document.activeElement)) {
        e.preventDefault();
        collectFocusable(modal);
        (firstFocusableEl || modal.querySelector('.PersClose') || modal).focus();
        return;
      }

      if (!focusableEls.length) return;

      if (!modal.contains(document.activeElement)) {
        e.preventDefault();
        (firstFocusableEl || modal.querySelector('.PersClose') || modal).focus();
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl?.focus();
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl?.focus();
        }
      }
    }

    function trapFocus(modalRoot) {
      collectFocusable(modalRoot);
      modalRoot.addEventListener('keydown', handleTrapTab);
    }

    function releaseFocus(modalRoot) {
      modalRoot.removeEventListener('keydown', handleTrapTab);
    }

    let lockedScrollY = 0;

    function lockPageScroll() {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;

      document.documentElement.setAttribute('scroll-lock', '');
      document.body.setAttribute('scroll-lock', '');

      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockPageScroll() {
      document.documentElement.removeAttribute('scroll-lock');
      document.body.removeAttribute('scroll-lock');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';

      window.scrollTo(0, lockedScrollY);
    }

    // ----- EVENTI
    const openModal = async () => {
      await ensureProductJson();
      await ensurePersProductJson();
      prevActiveElement = document.activeElement;

      const displayedPriceEl = getDisplayedPriceEl();
      if (displayedPriceEl && baseDisplayedPriceCents == null) {
        baseDisplayedPriceCents = parseMoneyToCents(displayedPriceEl.textContent);
      }

      modal.setAttribute('aria-hidden', 'false');
      lockPageScroll();

      const head = document.querySelector('header');
      if (head?.style) head.style.zIndex = '0';

      gotoStep(1);
      mountSharedPickerForInput(bottleInput);

      setTimeout(() => {
        trapFocus(modal);
        collectFocusable(modal);
        (modal.querySelector('.PersClose') || firstFocusableEl || modal).focus();
      }, 10);
    };

    function closeModal() {
      syncPersonalizerStateFromInputs();

      modal.setAttribute('aria-hidden', 'true');
      unlockPageScroll();

      const head = document.querySelector('header');
      if (head?.style) head.style.zIndex = '';

      releaseFocus(modal);

      requestAnimationFrame(() => {
        if (prevActiveElement && typeof prevActiveElement.focus === 'function') {
          prevActiveElement.focus();
        } else if (!openBtn.classList.contains('hidden')) {
          openBtn?.focus();
        } else {
          editBtn?.focus();
        }
      });
    }

    openBtn.addEventListener('click', openModal);
    editBtn?.addEventListener('click', openModal);
    backdrop.addEventListener('click', closeModal);
    closeBtns.forEach(b => b.addEventListener('click', closeModal));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    tabs.forEach(t =>
      t.addEventListener('click', () => gotoStep(Number(t.dataset.stepTarget || '1')))
    );

    btnNexts.forEach(btn =>
      btn.addEventListener('click', () => gotoStep(2))
    );

    btnConfirms.forEach(btn =>
      btn.addEventListener('click', () => {
        closeModal();
      })
    );

    // =========================================================
    //  ICON PICKER CONDIVISO
    // =========================================================

    const ICON_LIST = [
      { icon: '\u263A',       label: 'Smile',      weight: 1 },
      { icon: '\u2605',       label: 'Stella',     weight: 1 },
      { icon: '\u273F',       label: 'Fiore',      weight: 1 },
      { icon: '\u2665',       label: 'Cuore',      weight: 1 },
      { icon: '\u266B',       label: 'Nota',       weight: 1 },
      { icon: '\u2600',       label: 'Sole',       weight: 1 },
      { icon: '\u2601',       label: 'Nuvola',     weight: 1 },
      { icon: '\u262E',       label: 'Pace',       weight: 1 },
      { icon: '\u221E',       label: 'Infinito',   weight: 1 },

      { icon: '\u2648\uFE0E', label: 'Ariete',     weight: 2 },
      { icon: '\u2649\uFE0E', label: 'Toro',       weight: 2 },
      { icon: '\u264A\uFE0E', label: 'Gemelli',    weight: 2 },
      { icon: '\u264B\uFE0E', label: 'Cancro',     weight: 2 },
      { icon: '\u264C\uFE0E', label: 'Leone',      weight: 2 },
      { icon: '\u264D\uFE0E', label: 'Vergine',    weight: 2 },
      { icon: '\u264E\uFE0E', label: 'Bilancia',   weight: 2 },
      { icon: '\u264F\uFE0E', label: 'Scorpione',  weight: 2 },
      { icon: '\u2650\uFE0E', label: 'Sagittario', weight: 2 },
      { icon: '\u2651\uFE0E', label: 'Capricorno', weight: 2 },
      { icon: '\u2652\uFE0E', label: 'Acquario',   weight: 2 },
      { icon: '\u2653\uFE0E', label: 'Pesci',      weight: 2 }
    ];

    let activeIconInput = null;

    const ICON_VALUES = ICON_LIST.map(x => x.icon).sort((a, b) => b.length - a.length);

    const ICON_WEIGHT_MAP = new Map(
      ICON_LIST.map(x => [x.icon, Number(x.weight || 1)])
    );

    function getTokenWeight(token) {
      return ICON_WEIGHT_MAP.get(token) || 1;
    }

    function getTextGraphemes(str) {
      const text = String(str || '');
      try {
        if (typeof Intl !== 'undefined' && Intl.Segmenter) {
          const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
          return Array.from(seg.segment(text), x => x.segment);
        }
      } catch {}
      return Array.from(text);
    }

    function tokenizeValue(str) {
      const text = String(str || '');
      const tokens = [];
      let i = 0;

      while (i < text.length) {
        let matchedIcon = null;

        for (const icon of ICON_VALUES) {
          if (text.slice(i, i + icon.length) === icon) {
            matchedIcon = icon;
            break;
          }
        }

        if (matchedIcon) {
          tokens.push(matchedIcon);
          i += matchedIcon.length;
          continue;
        }

        const rest = text.slice(i);
        const graphemes = getTextGraphemes(rest);
        const first = graphemes[0] || rest.charAt(0);

        tokens.push(first);
        i += first.length;
      }

      return tokens;
    }

    function getCharCount(str) {
      return tokenizeValue(str).reduce((sum, token) => {
        return sum + getTokenWeight(token);
      }, 0);
    }

    function getInputMaxChars(inputEl) {
      return Number(inputEl?.getAttribute('maxlength') || 0);
    }

    function codeUnitIndexToTokenIndex(str, codeUnitIndex) {
      const text = String(str || '');
      const safeIndex = Math.max(0, Math.min(codeUnitIndex ?? text.length, text.length));

      let consumed = 0;
      let tokenIndex = 0;
      const tokens = tokenizeValue(text);

      for (const token of tokens) {
        if (consumed >= safeIndex) break;
        consumed += token.length;
        tokenIndex++;
      }

      return tokenIndex;
    }

    function tokenIndexToCodeUnitIndex(str, tokenIndex) {
      const tokens = tokenizeValue(str);
      const safeIndex = Math.max(0, Math.min(tokenIndex ?? tokens.length, tokens.length));
      return tokens.slice(0, safeIndex).join('').length;
    }

    function trimToMaxChars(value, maxChars) {
      if (!maxChars || maxChars <= 0) return String(value || '');

      const tokens = tokenizeValue(value);
      const out = [];
      let used = 0;

      for (const token of tokens) {
        const weight = getTokenWeight(token);
        if (used + weight > maxChars) break;
        out.push(token);
        used += weight;
      }

      return out.join('');
    }

    function enforceMaxChars(inputEl) {
      if (!inputEl) return;

      const max = getInputMaxChars(inputEl);
      if (!max) return;

      const oldValue = String(inputEl.value || '');
      const oldStartCU = inputEl.selectionStart ?? oldValue.length;

      const oldStartToken = codeUnitIndexToTokenIndex(oldValue, oldStartCU);
      const trimmed = trimToMaxChars(oldValue, max);

      if (trimmed !== oldValue) {
        inputEl.value = trimmed;

        const nextPosCU = tokenIndexToCodeUnitIndex(
          trimmed,
          Math.min(oldStartToken, getCharCount(trimmed))
        );

        try {
          inputEl.setSelectionRange(nextPosCU, nextPosCU);
        } catch {}
      }
    }

    function insertTextAtCursorWithLimit(inputEl, textToInsert) {
      if (!inputEl) return false;

      const currentValue = String(inputEl.value || '');
      const maxChars = getInputMaxChars(inputEl);

      const startCU = inputEl.selectionStart ?? currentValue.length;
      const endCU   = inputEl.selectionEnd   ?? currentValue.length;

      const startToken = codeUnitIndexToTokenIndex(currentValue, startCU);
      const endToken   = codeUnitIndexToTokenIndex(currentValue, endCU);

      const currentTokens = tokenizeValue(currentValue);
      const insertTokens  = tokenizeValue(textToInsert);

      const before = currentTokens.slice(0, startToken);
      const after  = currentTokens.slice(endToken);

      let allowedInsertTokens = insertTokens;

      if (maxChars > 0) {
        const usedBefore = before.reduce((sum, token) => sum + getTokenWeight(token), 0);
        const usedAfter  = after.reduce((sum, token) => sum + getTokenWeight(token), 0);
        let available = Math.max(0, maxChars - usedBefore - usedAfter);

        allowedInsertTokens = [];
        for (const token of insertTokens) {
          const weight = getTokenWeight(token);
          if (weight > available) break;
          allowedInsertTokens.push(token);
          available -= weight;
        }
      }

      const nextTokens = [...before, ...allowedInsertTokens, ...after];
      const nextValue = nextTokens.join('');

      inputEl.value = nextValue;

      const caretToken = before.length + allowedInsertTokens.length;
      const caretCU = tokenIndexToCodeUnitIndex(nextValue, caretToken);

      inputEl.focus();
      try {
        inputEl.setSelectionRange(caretCU, caretCU);
      } catch {}

      return allowedInsertTokens.length > 0;
    }

    function createSharedIconPicker() {
      const picker = document.createElement('div');
      picker.className = 'IconPicker IconPicker--shared';

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'IconPicker__toggle';
      toggle.setAttribute('aria-label', 'Inserisci icona');
      toggle.textContent = '\u263A';

      const dropdown = document.createElement('div');
      dropdown.className = 'IconPicker__dropdown hidden';

      ICON_LIST.forEach(entry => {
        const opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'IconPicker__option';
        opt.dataset.icon = entry.icon;
        opt.title = entry.label;
        opt.textContent = entry.icon;
        dropdown.appendChild(opt);
      });

      picker.appendChild(toggle);
      picker.appendChild(dropdown);
      return picker;
    }

    const sharedIconPicker = createSharedIconPicker();
    const sharedIconToggle = sharedIconPicker.querySelector('.IconPicker__toggle');
    const sharedIconDropdown = sharedIconPicker.querySelector('.IconPicker__dropdown');

    function mountSharedPickerForInput(inputEl) {
      if (!inputEl) return;

      activeIconInput = inputEl;

      const row = inputEl.closest('.IconPickerRow');
      if (!row) return;

      row.querySelectorAll('.IconPicker[data-position="front"]').forEach(el => {
        el.classList.add('hidden');
        el.setAttribute('aria-hidden', 'true');
      });

      const backSlot = row.querySelector('.IconPicker[data-position="back"]');
      if (!backSlot) return;

      backSlot.classList.remove('hidden');
      backSlot.setAttribute('aria-hidden', 'false');

      if (sharedIconPicker.parentNode !== backSlot) {
        backSlot.innerHTML = '';
        backSlot.appendChild(sharedIconPicker);
      }
    }

    function buildPreviewHTML(target, text) {
      return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function buildPreviewString(target, text) {
      return String(text || '');
    }

    const measureSpan = document.createElement('span');
    measureSpan.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;font-weight:700;letter-spacing:.08em;';
    measureSpan.style.fontFamily = "'Segoe UI Symbol', sans-serif";
    document.body.appendChild(measureSpan);

    function fitPreviewText() {
      if (!previewText) return;
      const stage = previewText.closest('.PersStage');
      if (!stage) return;

      const minSize = 6;
      let size = 12;

      const isStep1 = stage.classList.contains('is-step-1');

      // ← abbassa il numero per restringere prima (0.35 = default, 0.25 = più corto)
      const ratio = isStep1 ? 0.30 : 0.35;
      const maxLen = isStep1 ? stage.offsetHeight * ratio : stage.offsetWidth * ratio;

      measureSpan.textContent = previewText.textContent;
      measureSpan.style.fontSize = size + 'px';

      while (measureSpan.offsetWidth > maxLen && size > minSize) {
        size -= 2;
        measureSpan.style.fontSize = size + 'px';
      }

      previewText.style.fontSize = size + 'px';
    }

    function updatePreview() {
      if (currentStep === 1) {
        previewText.innerHTML = buildPreviewHTML('bottle', bottleInput.value);
      } else {
        previewText.innerHTML = buildPreviewHTML('stick', stickInput.value);
      }
      fitPreviewText();
    }

    sharedIconToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      sharedIconDropdown.classList.toggle('hidden');
    });

    sharedIconDropdown.querySelectorAll('.IconPicker__option').forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();

        if (!activeIconInput) return;

        const icon = opt.dataset.icon || '';
        insertTextAtCursorWithLimit(activeIconInput, icon);

        sharedIconDropdown.classList.add('hidden');

        if (activeIconInput === bottleInput) {
          onBottleInput();
        } else if (activeIconInput === stickInput) {
          onStickInput();
        }
      });
    });

    document.addEventListener('click', () => {
      sharedIconDropdown.classList.add('hidden');
    });

    function bindSharedPickerToInput(inputEl) {
      if (!inputEl) return;

      const activate = () => mountSharedPickerForInput(inputEl);
      inputEl.addEventListener('focus', activate);
      inputEl.addEventListener('click', activate);
    }

    bindSharedPickerToInput(bottleInput);
    bindSharedPickerToInput(stickInput);

    modal.querySelectorAll('.IconPicker[data-position="front"]').forEach(el => {
      el.classList.add('hidden');
      el.setAttribute('aria-hidden', 'true');
    });

    function formatCount(input) {
      const max = input.getAttribute('maxlength') || '18';
      return getCharCount(input.value) + '/' + max;
    }

    function onBottleInput() {
      enforceMaxChars(bottleInput);

      if (step1.classList.contains('is-active')) updatePreview();
      if (bottleCount)       bottleCount.textContent = formatCount(bottleInput);
      if (bottleCountInline) bottleCountInline.textContent = formatCount(bottleInput);

      syncAcceleratedCheckoutAdditionalItem();
      refreshFooterAndNote();
    }

    function onStickInput() {
      stickInput.value = stickInput.value.toUpperCase();
      enforceMaxChars(stickInput);

      if (step2.classList.contains('is-active')) updatePreview();
      if (stickCount)       stickCount.textContent = formatCount(stickInput);
      if (stickCountInline) stickCountInline.textContent = formatCount(stickInput);

      syncAcceleratedCheckoutAdditionalItem();
      refreshFooterAndNote();
    }

    bottleInput.addEventListener('input', onBottleInput);
    stickInput.addEventListener('input', onStickInput);

    function bindBeforeInputLimit(inputEl, handler) {
      if (!inputEl) return;

      inputEl.addEventListener('beforeinput', () => {
        requestAnimationFrame(handler);
      });

      inputEl.addEventListener('paste', () => {
        requestAnimationFrame(handler);
      });
    }

    bindBeforeInputLimit(bottleInput, onBottleInput);
    bindBeforeInputLimit(stickInput, onStickInput);

    bindMaxLenMessageFor(bottleInput);
    bindMaxLenMessageFor(stickInput);

    function collectFormProperties(form) {
      const out = {};
      if (!form) return out;

      Array.from(form.querySelectorAll('input[name^="properties["]')).forEach((el) => {
        const match = el.name.match(/^properties\[(.*)\]$/);
        if (!match) return;
        const key = match[1];
        if (el.value != null && String(el.value).trim() !== '') {
          out[key] = el.value;
        }
      });

      return out;
    }

    function getQuantity() {
      const qtyInput = productForm?.querySelector('[name="quantity"]');
      const qty = Number(qtyInput?.value || 1);
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }
    
    function ensureHiddenInput(form, name) {
      if (!form) return null;

      let input = form.querySelector(`input[name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      return input;
    }

    function removeHiddenInput(form, name) {
      if (!form) return;
      const input = form.querySelector(`input[name="${name}"]`);
      if (input) input.remove();
    }

    function syncAcceleratedCheckoutAdditionalItem() {
      if (!productForm) return;

      removeHiddenInput(productForm, 'shopify-additional-items[1][id]');
      removeHiddenInput(productForm, 'shopify-additional-items[1][quantity]');
      removeHiddenInput(productForm, 'shopify-additional-items[1][parent_id]');

      const wantedValue = computeWantedValue();
      if (wantedValue === VAL.no) return;

      const mainVariantId = getCurrentVariantId();
      const persVariant = findPersVariantByValue(wantedValue);
      const quantity = getQuantity();

      if (!mainVariantId || !persVariant?.id) return;

      ensureHiddenInput(productForm, 'shopify-additional-items[1][id]').value = String(persVariant.id);
      ensureHiddenInput(productForm, 'shopify-additional-items[1][quantity]').value = String(quantity);
      ensureHiddenInput(productForm, 'shopify-additional-items[1][parent_id]').value = String(mainVariantId);
    }

    const quantityInput = productForm?.querySelector('[name="quantity"]');
    if (quantityInput) {
      quantityInput.addEventListener('change', syncAcceleratedCheckoutAdditionalItem);
      quantityInput.addEventListener('input', syncAcceleratedCheckoutAdditionalItem);
    }

    function getVisibleCartCount(cartData) {
      if (!cartData?.items?.length) return 0;

      return cartData.items.reduce((sum, item) => {
        const isPersonalization = item.properties && item.properties._is_personalization === '1';
        if (isPersonalization) return sum;
        return sum + (Number(item.quantity) || 0);
      }, 0);
    }

    async function updateCartBubbleCount() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await res.json();

        const visibleCount = getVisibleCartCount(cart);

        document.querySelectorAll('[ref="cartBubble"]').forEach((bubble) => {
          bubble.classList.toggle('visually-hidden', visibleCount === 0);

          const countEl = bubble.querySelector('[ref="cartBubbleCount"]');
          const textEl = bubble.querySelector('.visually-hidden');

          if (countEl) {
            countEl.textContent = visibleCount > 99 ? '99+' : String(visibleCount);
            countEl.classList.toggle('hidden', visibleCount === 0);
          }

          if (textEl) {
            textEl.textContent = `Totale articoli nel carrello: ${visibleCount}`;
          }

          bubble.classList.remove('is-updated');
          void bubble.offsetWidth;
          bubble.classList.add('is-updated');
        });
      } catch (err) {
        console.error(err);
      }
    }

    async function refreshSectionById(sectionId) {
      if (!sectionId) return;

      const currentRoots = document.querySelectorAll(`[data-section-id="${sectionId}"]`);
      if (!currentRoots.length) return;

      try {
        const res = await fetch(`/?sections=${encodeURIComponent(sectionId)}`, {
          credentials: 'same-origin'
        });
        const sections = await res.json();
        const html = sections[sectionId];
        if (!html) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = parsed.querySelector(`[data-section-id="${sectionId}"]`);
        if (!newRoot) return;

        currentRoots.forEach((currentRoot) => {
          currentRoot.replaceWith(newRoot.cloneNode(true));
        });
      } catch (err) {
        console.error(err);
      }
    }

    async function refreshCartUI() {
      const sectionIds = Array.from(
        new Set(
          Array.from(document.querySelectorAll('[data-section-id]'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean)
            .filter((id) => /cart|drawer|header|bubble/i.test(id))
        )
      );

      for (const sectionId of sectionIds) {
        await refreshSectionById(sectionId);
      }

      await updateCartBubbleCount();

      const drawer =
        document.querySelector('cart-drawer-component[auto-open]') ||
        document.querySelector('cart-drawer-component');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    }

    let isSubmittingBundle = false;

    async function handleBundledAddToCart() {
      syncPersonalizerStateFromInputs();
      applyCurrentValues();

      const wantedValue = computeWantedValue();
      if (wantedValue === VAL.no) return false;

      const mainVariantId = getCurrentVariantId();
      if (!mainVariantId) return false;

      await ensurePersProductJson();
      const persVariant = findPersVariantByValue(wantedValue);
      if (!persVariant) return false;

      if (isSubmittingBundle) return true;
      isSubmittingBundle = true;

      const quantity = getQuantity();
      const token = `pers_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

      const mainProperties = collectFormProperties(productForm);
      mainProperties._pers_token = token;
      mainProperties._pers_value = wantedValue;

      const childProperties = {
        _is_personalization: '1',
        _pers_token: token,
        _parent_product_id: String(productId || ''),
        _parent_variant_id: String(mainVariantId),
        _pers_value: wantedValue
      };

      const bottleVal = bottleInput.value.trim();
      const stickVal  = stickInput.value.trim();

      if (bottleVal) childProperties['Testo flacone'] = bottleVal;
      if (stickVal)  childProperties['Testo bastoncino'] = stickVal;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(mainVariantId),
                quantity,
                properties: mainProperties
              },
              {
                id: Number(persVariant.id),
                quantity,
                properties: childProperties
              }
            ]
          })
        });

        if (!res.ok) throw new Error('Add to cart failed');

        await refreshCartUI();

        isSubmittingBundle = false;
        return true;
      } catch (err) {
        console.error(err);
        isSubmittingBundle = false;
        return false;
      }
    }

    const addToCartBtn =
      productForm?.querySelector('[type="submit"][name="add"]') ||
      productForm?.querySelector('.add-to-cart-button') ||
      productForm?.querySelector('button[type="submit"]');

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async (e) => {
        const wantedValue = computeWantedValue();
        if (wantedValue === VAL.no) return;

        e.preventDefault();
        e.stopPropagation();

        await handleBundledAddToCart();
      });
    }

    const onVariantEvent = () => {
      setTimeout(() => {
        syncAcceleratedCheckoutAdditionalItem();
        refreshFooterAndNote();
      }, 0);
    };

    document.addEventListener('variant:update', onVariantEvent, { passive: true });
    document.addEventListener('variant:change', onVariantEvent, { passive: true });

    updateSummary();
    observePriceContainer();

    requestAnimationFrame(() => {
      mountSharedPickerForInput(bottleInput);
      syncPersonalizerStateFromInputs();
    });

    window.addEventListener('pageshow', (event) => {
      requestAnimationFrame(() => {
        syncPersonalizerStateFromInputs();

        if (event.persisted) {
          syncAcceleratedCheckoutAdditionalItem();
          refreshFooterAndNote();
        }
      });
    });
  })();

  /* Selettore lingua custom — animazione altezza reale + nascondi lingua attiva */
  (function () {
    const wrappers = document.querySelectorAll('[data-custom-select]');

    const closeAll = (except = null) => {
      wrappers.forEach(w => {
        if (w !== except) {
          w.classList.remove('is-open');
          const trg = w.querySelector('.custom-select-trigger');
          const dd  = w.querySelector('.custom-select-dropdown');
          trg?.setAttribute('aria-expanded', 'false');
          if (dd) dd.style.setProperty('--menu-h', '0px');
        }
      });
    };

    const setMenuHeight = (dd) => {
      dd.style.setProperty('--menu-h', dd.scrollHeight + 'px');
    };

    wrappers.forEach(wrapper => {
      const trigger      = wrapper.querySelector('.custom-select-trigger');
      const dropdown     = wrapper.querySelector('.custom-select-dropdown');
      const hiddenSelect = wrapper.querySelector('.localization-form__select');
      const valueDisplay = wrapper.querySelector('.custom-select-value');

      // collega trigger ↔ listbox per a11y
      const listboxId = dropdown.id || `cs-listbox-${Math.random().toString(36).slice(2)}`;
      dropdown.id = listboxId;
      trigger.setAttribute('aria-controls', listboxId);

      // helper: costruisce il menu a partire dalla <select>, escludendo l'opzione attiva
      const buildDropdown = () => {
        const activeValue = hiddenSelect.value;
        dropdown.innerHTML = ''; // reset

        const opts = Array.from(hiddenSelect.options)
          .filter(o => o.value && o.value !== activeValue);

        // crea bottoni opzione
        opts.forEach(o => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'custom-select-option';
          btn.setAttribute('role', 'option');
          btn.dataset.value = o.value;
          btn.dataset.lang = o.getAttribute('lang') || o.value;
          btn.setAttribute('aria-selected', 'false');
          btn.textContent = (o.textContent || '').trim();
          dropdown.appendChild(btn);

          // listener selezione
          btn.addEventListener('click', () => {
            // aggiorna UI
            valueDisplay.textContent = btn.textContent;
            // aggiorna hidden select
            hiddenSelect.value = btn.dataset.value;

            // chiudi
            wrapper.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            dropdown.style.setProperty('--menu-h', '0px');

            // dispatch change per innescare il cambio lingua
            hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

            // ricostruisci il menu per nascondere la nuova attiva
            buildDropdown();
            trigger.focus();
          });
        });

        // aggiorna il testo nel trigger in base alla selezionata
        const selectedOption = hiddenSelect.options[hiddenSelect.selectedIndex];
        if (selectedOption) {
          valueDisplay.textContent = (selectedOption.textContent || '').trim();
        }

        // disabilita se non ci sono altre lingue
        const hasChoices = dropdown.querySelector('.custom-select-option') !== null;
        trigger.disabled = !hasChoices;
        trigger.setAttribute('aria-disabled', String(!hasChoices));
        wrapper.classList.toggle('is-disabled', !hasChoices);

        // se è aperto, ricalcola l'altezza
        if (wrapper.classList.contains('is-open')) setMenuHeight(dropdown);
      };

      // osserva cambi dimensione contenuto (responsive / font / etc.)
      const ro = new ResizeObserver(() => {
        if (wrapper.classList.contains('is-open')) setMenuHeight(dropdown);
      });
      ro.observe(dropdown);

      // inizializza menu
      buildDropdown();

      // toggle open/close
      trigger.addEventListener('click', () => {
        if (trigger.disabled) return;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        if (!expanded) {
          closeAll(wrapper);
          wrapper.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          setMenuHeight(dropdown);
          // focus alla prima opzione disponibile
          const first = dropdown.querySelector('.custom-select-option');
          first?.focus({ preventScroll: true });
        } else {
          wrapper.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.style.setProperty('--menu-h', '0px');
          trigger.focus();
        }
      });

      // click fuori
      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
          wrapper.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.style.setProperty('--menu-h', '0px');
        }
      });

      // tastiera: apri/chiudi dal trigger
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger.click(); }
        if (e.key === 'ArrowDown') { e.preventDefault(); if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click(); }
      });

      // tastiera nel listbox: roving focus
      dropdown.addEventListener('keydown', (e) => {
        const focusables = Array.from(dropdown.querySelectorAll('.custom-select-option'));
        const i = focusables.indexOf(document.activeElement);
        if (!focusables.length) return;

        if (e.key === 'ArrowDown') { e.preventDefault(); (focusables[i + 1] || focusables[0])?.focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (focusables[i - 1] || focusables.at(-1))?.focus(); }
        else if (e.key === 'Home') { e.preventDefault(); focusables[0]?.focus(); }
        else if (e.key === 'End') { e.preventDefault(); focusables.at(-1)?.focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.activeElement?.click(); }
        else if (e.key === 'Escape') {
          wrapper.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          dropdown.style.setProperty('--menu-h', '0px');
          trigger.focus();
        }
      });

      // se qualcuno aggiorna la <select> da fuori, ricostruisci (robustezza)
      hiddenSelect.addEventListener('change', () => buildDropdown());
    });
  })();

  // Sticky Cart Button per Shopify con supporto per product-form-component
  (function() {
    'use strict';
    
    const MOBILE_BREAKPOINT = 768;
    let stickyContainer = null;
    let addToCartBtn = null;
    let stateObserver = null;

    /**
     * Trova il bottone "aggiungi al carrello"
     */
    function findAddToCartButton() {
      const selectors = [
        '.buttons-wrapper [type="submit"]',
        'product-form-component [type="submit"]',
        'form[data-type="add-to-cart-form"] [type="submit"]',
        '[name="add"]',
        '.product-form__submit'
      ];
      
      for (const selector of selectors) {
        const btn = document.querySelector(selector);
        if (btn && btn.offsetParent !== null) {
          return btn;
        }
      }
      return null;
    }

    /**
     * Ritorna info sulla capacità selezionata:
     * { legend: 'Capacità', value: '100 ml' }
     *
     * 1) Cerca il fieldset che contiene un radio checked con testo che contiene "ml"
     * 2) Fallback: fieldset con legend che include "capacità"
     */
    function getCapacityInfo() {
      const form = document.querySelector('.variant-picker__form');
      if (!form) return { legend: '', value: '' };

      const fieldsets = form.querySelectorAll('fieldset');

      // 1) priorità al fieldset che contiene "ml" nel testo del radio selezionato
      for (const fieldset of fieldsets) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) continue;

        const legendEl = fieldset.querySelector('legend');
        const label = checked.closest('label');
        let labelTextEl = null;
        let text = '';

        if (label) {
          labelTextEl = label.querySelector('.variant-option__checkbox-label__text');
          if (labelTextEl && labelTextEl.textContent) {
            text = labelTextEl.textContent;
          }
        }

        if (!text) {
          text = checked.getAttribute('aria-label') || checked.value || '';
        }

        if (/ml\b/i.test(text)) {
          return {
            legend: legendEl ? legendEl.textContent.trim() : '',
            value: text.trim()
          };
        }
      }

      // 2) fallback: legend che contiene "capacità"
      for (const fieldset of fieldsets) {
        const legendEl = fieldset.querySelector('legend');
        if (!legendEl) continue;

        if (legendEl.textContent.trim().toLowerCase().includes('capacità')) {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (checked) {
            const label = checked.closest('label');
            let labelTextEl = null;
            let text = '';

            if (label) {
              labelTextEl = label.querySelector('.variant-option__checkbox-label__text');
              if (labelTextEl && labelTextEl.textContent) {
                text = labelTextEl.textContent;
              }
            }

            if (!text) {
              text = checked.getAttribute('aria-label') || checked.value || '';
            }

            return {
              legend: legendEl.textContent.trim(),
              value: text.trim()
            };
          }
        }
      }

      return { legend: '', value: '' };
    }
    
    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }
    
    function handleScroll() {
      if (!stickyContainer || !addToCartBtn) return;
      
      if (!isMobile()) {
        stickyContainer.style.display = 'none';
        stickyContainer.style.transform = 'translateY(100%)';
        stickyContainer.style.opacity = '0';
        return;
      }
      
      try {
        const addToCartRect = addToCartBtn.getBoundingClientRect();
        const isOriginalBelowViewport = addToCartRect.top < 0;
        
        if (isOriginalBelowViewport) {
          stickyContainer.style.display = 'block';
          requestAnimationFrame(() => {
            stickyContainer.style.transform = 'translateY(0)';
            stickyContainer.style.opacity = '1';
          });
        } else {
          stickyContainer.style.transform = 'translateY(100%)';
          stickyContainer.style.opacity = '0';
          setTimeout(() => {
            if (stickyContainer.style.transform === 'translateY(100%)') {
              stickyContainer.style.display = 'none';
            }
          }, 300);
        }
      } catch (error) {
        console.error('Errore nello sticky cart:', error);
      }
    }
    
    /**
     * Click sul bottone sticky → click reale sul bottone originale
     */
    function triggerAddToCart(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!addToCartBtn) return;

      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });

      addToCartBtn.dispatchEvent(clickEvent);
    }

    /**
     * Sincronizza lo stato del bottone sticky con quello originale
     */
    function syncButtonState(clonedBtn) {
      function fullSync() {
        // classi
        clonedBtn.className = addToCartBtn.className;
        clonedBtn.style.width = '100%';
        
        // disabled
        if (addToCartBtn.hasAttribute('disabled')) {
          clonedBtn.setAttribute('disabled', '');
        } else {
          clonedBtn.removeAttribute('disabled');
        }
        
        // aria-disabled
        const ariaDisabled = addToCartBtn.getAttribute('aria-disabled');
        if (ariaDisabled) {
          clonedBtn.setAttribute('aria-disabled', ariaDisabled);
        } else {
          clonedBtn.removeAttribute('aria-disabled');
        }
        
        // contenuto (testo, icone, stato "Aggiunto", ecc.)
        clonedBtn.innerHTML = addToCartBtn.innerHTML;
      }
      
      stateObserver = new MutationObserver(function() {
        setTimeout(fullSync, 50);
      });
      
      stateObserver.observe(addToCartBtn, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled']
      });
      
      fullSync();
    }

    /**
     * Scroll verso il variant picker quando clicchi la freccia
     */
    function scrollToVariants(e) {
      e.preventDefault();

      const form = document.querySelector('.variant-picker__form');
      if (!form) return;

      const rect = form.getBoundingClientRect();
      const offset = 100; // margine per l'header
      const targetY = window.scrollY + rect.top - offset;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });
    }

    /**
     * Sincronizza legend + capacità accanto al bottone sticky
     */
    function setupCapacitySync(legendEl, valueEl) {
      const form = document.querySelector('.variant-picker__form');
      if (!form) {
        legendEl.style.display = 'none';
        valueEl.style.display = 'none';
        return;
      }

      const updateCapacity = () => {
        const info = getCapacityInfo();
        if (info.value) {
          if (info.legend) {
            legendEl.textContent = info.legend;
            legendEl.style.display = 'block';
          } else {
            legendEl.textContent = '';
            legendEl.style.display = 'none';
          }

          valueEl.textContent = info.value;
          valueEl.style.display = 'inline';
        } else {
          legendEl.textContent = '';
          valueEl.textContent = '';
          legendEl.style.display = 'none';
          valueEl.style.display = 'none';
        }
      };

      form.addEventListener('change', updateCapacity);
      updateCapacity();
    }
    
    function initStickyButton() {
      try {
        addToCartBtn = findAddToCartButton();
        
        if (!addToCartBtn) {
          return false;
        }
        
        if (document.querySelector('.sticky-cart-mobile')) {
          return false;
        }
        
        stickyContainer = document.createElement('div');
        stickyContainer.className = 'sticky-cart-mobile';
        stickyContainer.style.cssText = `
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: white;
          box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
          padding: 12px 16px;
          z-index: 4;
          transform: translateY(100%);
          transition: transform 0.3s ease, opacity 0.3s ease;
          display: none;
          opacity: 0;
          border-top: 1px solid black;
        `;

        // wrapper interno per bottone + blocco varianti
        const innerWrapper = document.createElement('div');
        innerWrapper.style.cssText = `
          display: flex;
          align-items: center;
          gap: 32px;
        `;
        
        // Clona il bottone
        const clonedBtn = addToCartBtn.cloneNode(true);
        clonedBtn.style.width = '100%';
        clonedBtn.style.flex = '1 1 auto';
        clonedBtn.style.position = 'relative';
        
        // Rimuovi ID duplicati e attributi inutili
        if (clonedBtn.id) {
          clonedBtn.removeAttribute('id');
        }
        clonedBtn.removeAttribute('form');
        clonedBtn.removeAttribute('ref');
        clonedBtn.removeAttribute('on:click');
        clonedBtn.type = 'button';

        // Wrapper per legend + capacità + freccia
        const capacityWrapper = document.createElement('div');
        capacityWrapper.className = 'sticky-cart-variant-wrapper';
        capacityWrapper.style.cssText = `
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
        `;

        // Legend (es. "Capacità")
        const capacityLegend = document.createElement('span');
        capacityLegend.className = 'sticky-cart-variant-legend';

        // Riga con valore + freccia
        const capacityRow = document.createElement('div');
        capacityRow.style.cssText = `
          display: flex;
          align-items: center;
          gap: 4px;
          margin-top: 2px;
        `;

        // Valore (es. "100 ml")
        const capacityValue = document.createElement('span');
        capacityValue.className = 'sticky-cart-variant';
        capacityValue.style.cssText = `
          white-space: nowrap;
          font-size: 14px;
        `;

        // Bottone freccia per tornare alle varianti
        const variantsArrowButton = document.createElement('button');
        variantsArrowButton.type = 'button';
        variantsArrowButton.className = 'sticky-cart-variants-arrow';
        variantsArrowButton.setAttribute('aria-label', 'Modifica varianti');
        variantsArrowButton.style.cssText = `
          flex: 0 0 auto;
          border: none;
          background: none;
          padding: 0;
          margin: 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          aspect-ratio: 1/1;
          width: 40px;
        `;

        // Icona SVG fornita
        variantsArrowButton.innerHTML = `
          <svg width="16" height="auto" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.140625 5.31721C2.60851 3.64195 4.14063 0.561523 4.14063 0.561523M4.14063 0.561523C4.14063 0.561523 5.67274 3.64498 8.14063 5.31721M4.14063 0.561523L4.14065 10.5615" stroke="black" stroke-width="0.5" stroke-miterlimit="10"/>
          </svg>
        `;

        variantsArrowButton.addEventListener('click', scrollToVariants);

        capacityWrapper.appendChild(capacityLegend);
        capacityWrapper.appendChild(capacityValue);
        
        innerWrapper.appendChild(clonedBtn);
        innerWrapper.appendChild(capacityWrapper);
        innerWrapper.appendChild(variantsArrowButton);
        stickyContainer.appendChild(innerWrapper);
        document.body.appendChild(stickyContainer);
        
        // Click sul clone → click sul bottone originale
        clonedBtn.addEventListener('click', triggerAddToCart);
        
        // Sincronizza bottone
        syncButtonState(clonedBtn);

        // Sincronizza legend + capacità
        setupCapacitySync(capacityLegend, capacityValue);
        
        let scrollTimeout;
        window.addEventListener('scroll', function() {
          if (scrollTimeout) clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(handleScroll, 10);
        }, { passive: true });
        
        window.addEventListener('resize', function() {
          handleScroll();
        }, { passive: true });
        
        handleScroll();
        
        return true;
      } catch (error) {
        console.error('Errore durante l\'inizializzazione dello sticky cart:', error);
        return false;
      }
    }
    
    function tryInit() {
      let attempts = 0;
      const maxAttempts = 5;
      
      function attempt() {
        attempts++;
        const success = initStickyButton();
        
        if (!success && attempts < maxAttempts) {
          setTimeout(attempt, 500);
        }
      }
      
      attempt();
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryInit);
    } else {
      tryInit();
    }
  })();

  /* ===============================
  * CART DRAWER — Related products dell'ultimo aggiunto
  * (Horizon-safe, NO edit tema)
  * =============================== */
  (() => {
    const RECO_EL_SEL = '#cart-drawer-recommendations';

    // Debounce per evitare reload multipli (che causano AbortError a cascata)
    let recoReloadT = null;
    function scheduleRecoReload(productId) {
      clearTimeout(recoReloadT);
      recoReloadT = setTimeout(() => {
        refreshCartRecommendations(productId);
      }, 250);
    }

    // ✅ ora accetta anche blank per pulire l'attributo
    async function persistLastAddedProductId(productIdOrBlank) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: { last_added_product_id: productIdOrBlank ? String(productIdOrBlank) : '' }
          })
        });
      } catch (err) {
        console.warn('[CartReco] Failed to persist last_added_product_id', err);
      }
    }

    function refreshCartRecommendations(productId) {
      const el = document.querySelector(RECO_EL_SEL);
      if (!el || !productId) return;

      const newId = String(productId);
      const oldId = String(el.dataset.productId || '');
      const performed = el.getAttribute('data-recommendations-performed') === 'true';

      // ✅ se è lo stesso prodotto e già performed, non rifare fetch (riduce abort)
      if (newId === oldId && performed) return;

      // aggiorna product id
      el.dataset.productId = newId;
      el.dataset.lastProductId = newId;

      // cache-buster SOLO quando cambia id (qui cambia per forza se siamo arrivati)
      try {
        const url = new URL(el.dataset.url, window.location.origin);
        url.searchParams.set('_ts', String(Date.now()));
        el.dataset.url = url.pathname + url.search;
      } catch (e) {
        // fallback semplice
        const base = (el.dataset.url || '').split('&_ts=')[0];
        el.dataset.url = base + (base.includes('?') ? '&' : '?') + `_ts=${Date.now()}`;
      }

      // reset stato per farlo ripartire
      el.removeAttribute('data-recommendations-performed');

      // se il custom element espone un metodo, chiamalo
      if (typeof el.loadRecommendations === 'function') {
        el.loadRecommendations();
      }
    }

    function extractProductIdFromEvent(e) {
      const d = e?.detail;

      if (d?.productId) return d.productId;
      if (d?.item?.product_id) return d.item.product_id;
      if (d?.item?.productId) return d.item.productId;

      if (d?.response?.product_id) return d.response.product_id;
      if (d?.response?.items?.[0]?.product_id) return d.response.items[0].product_id;

      return null;
    }

    async function getCartNoStore() {
      try {
        const res = await fetch('/cart.js', {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });
        if (!res.ok) return null;
        return await res.json();
      } catch {
        return null;
      }
    }

    function cartHasProductId(cart, pid) {
      const s = String(pid);
      return (cart?.items || []).some(it => String(it.product_id) === s);
    }

    function fallbackProductIdFromCart(cart) {
      const items = cart?.items || [];
      const last = items[items.length - 1];
      return last?.product_id ? String(last.product_id) : '';
    }

    // ✅ dopo change/update/clear: se last_added non è più nel cart, fallback sull'ultimo rimasto
    async function reconcileLastAddedAfterMutation() {
      const cart = await getCartNoStore();
      if (!cart) return;

      const attr = cart.attributes?.last_added_product_id
        ? String(cart.attributes.last_added_product_id)
        : '';

      let next = '';
      if (attr && cartHasProductId(cart, attr)) {
        next = attr;
      } else {
        next = fallbackProductIdFromCart(cart);
      }

      // aggiorna solo se cambia (evita loop)
      if (next !== attr) {
        await persistLastAddedProductId(next);
      }

      // ✅ aggiorna anche il drawer subito (se c'è un prodotto)
      if (next) scheduleRecoReload(next);
    }

    // --- 1) Hook su evento Horizon se disponibile
    function hookHorizonCartAddEvent() {
      const possibleNames = [
        'cart:add',
        'cart:added',
        'cart:add-item',
        'theme:cart:add',
        'CartAddEvent'
      ];

      possibleNames.forEach((name) => {
        document.addEventListener(name, async (e) => {
          let productId = extractProductIdFromEvent(e);

          // fallback cart
          if (!productId) {
            const cart = await getCartNoStore();
            productId = fallbackProductIdFromCart(cart);
          }
          if (!productId) return;

          await persistLastAddedProductId(productId);
          scheduleRecoReload(productId);
        });
      });
    }

    // --- 2) Fallback robusto: intercept fetch su /cart/add.js + mutations
    function hookFetchFallback() {
      const origFetch = window.fetch;
      if (origFetch.__cartRecoWrapped) return;

      function wrappedFetch(...args) {
        const p = origFetch.apply(this, args);

        try {
          const req = args[0];
          const url = (typeof req === 'string') ? req : (req?.url || '');
          const opts = args[1] || {};
          const method = (opts.method || req?.method || 'GET').toUpperCase();

          const isAdd =
            method === 'POST' &&
            url &&
            (url.includes('/cart/add') || url.includes('/cart/add.js'));

          const isMutation =
            method === 'POST' &&
            url &&
            (
              url.includes('/cart/change') || url.includes('/cart/change.js') ||
              url.includes('/cart/update') || url.includes('/cart/update.js') ||
              url.includes('/cart/clear')  || url.includes('/cart/clear.js')
            );

          // ADD: prendi product_id dalla risposta, persisti, aggiorna reco
          if (isAdd) {
            p.then(async (res) => {
              try {
                const data = await res.clone().json();
                const productId =
                  data?.product_id ||
                  data?.items?.[0]?.product_id ||
                  null;

                if (productId) {
                  await persistLastAddedProductId(productId);
                  scheduleRecoReload(productId);
                } else {
                  // fallback se non leggibile
                  await reconcileLastAddedAfterMutation();
                }
              } catch {
                await reconcileLastAddedAfterMutation();
              }
            });
          }

          // MUTATION: dopo che Horizon ha aggiornato sections/dom, riconcilia attr e ricarica
          if (isMutation) {
            p.then(() => {
              setTimeout(reconcileLastAddedAfterMutation, 200);
            });
          }
        } catch {}

        return p;
      }

      wrappedFetch.__cartRecoWrapped = true;
      window.fetch = wrappedFetch;
    }

    // init
    hookHorizonCartAddEvent();
    hookFetchFallback();

    // opzionale: al load riconcilia una volta (se l'attributo è "sporco" da sessione precedente)
    setTimeout(reconcileLastAddedAfterMutation, 300);
  })();

  /* Altezza breadcrumb PDP */
  const breadcrumbsEl = document.querySelector('.section-breadcrumbs');
  const breadcrumbsHeight = breadcrumbsEl ? breadcrumbsEl.getBoundingClientRect().height : 0;
  document.documentElement.style.setProperty('--breadcrumbs-height', `${breadcrumbsHeight}px`);
});